import React, { useState, useEffect, useRef } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import api from "../common/dependencies/utils/Api";
import swal from "sweetalert";
import {
  Typography,
  Button,
  Stepper,
  Step,
  StepLabel,
} from "@material-ui/core";
import Checkbox from "@mui/material/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import InputField from "../common/InputField";
import GlobalDropDown from "../common/GlobalDropDown";
import { Country, State, City } from "country-state-city";
import FormValidator from "./FormValidator";
import { useHistory } from "react-router-dom";
import hashImage from "../../assets/images/hashImage.jpeg";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "./styles.scss";
import MultiselectorComp from "../MultiselectorComp/MultiselectorComp.js";

import {
  registerMentor,
  savedraftMentor,
  getViewMentorApplicationData,
  getPredefineOptionsList,
} from "../BecomeMentorForms/dependencies/action";
import { VIEW_MENTOR_APPLICATION_DATA } from "../common/constants/ApplicationUrl";

// import { components } from "react-select";
import Select, { components, DropdownIndicatorProps } from "react-select";
import { PersonalVideoTwoTone } from "@material-ui/icons";

import { toast } from "react-toastify";
import { boolean } from "yup";
const industryOptions = [
  { value: "Marketing", label: "Marketing" },
  {
    value: "Aeronautics Aerospace & Defense",
    label: "Aeronautics Aerospace & Defense",
  },
  { value: "AI", label: "AI" },
  { value: "Analytics", label: "Analytics" },
  { value: "Animation", label: "Animation" },
  { value: "AR VR", label: "AR VR" },
  {
    value: "Architecture Interior Design",
    label: "Architecture Interior Design",
  },
  { value: "Art & Photography", label: "Art & Photography" },
  { value: "Automotive", label: "Automotive" },
  { value: "Chemicals", label: "Chemicals" },
  {
    value: "Telecommunication & Networking",
    label: "Telecommunication & Networking",
  },
  { value: "Computer Vision", label: "Computer Vision" },
  { value: "Construction", label: "Construction" },
  { value: "Dating Matrimonial", label: "Dating Matrimonial" },
  { value: "Design", label: "Design" },
  { value: "Education", label: "Education" },
  { value: "Non-Renewable Energy", label: "Non-Renewable Energy" },
  { value: "Green Technology", label: "Green Technology" },
  { value: "Enterprise Software", label: "Enterprise Software" },
  { value: "Events", label: "Events" },
  { value: "Fashion", label: "Fashion" },
  { value: "Finance Technology", label: "Finance Technology" },
  { value: "Food & Beverage", label: "Food & Beverage" },
  { value: "Healthcare & Lifesciences", label: "Healthcare & Lifesciences" },
  { value: "Human Resources", label: "Human Resources" },
  { value: "Internet of Things", label: "Internet of Things" },
  { value: "IT Services", label: "IT Services" },
  { value: "Media & Entertainment", label: "Media & Entertainment" },
  { value: "Nanotechnology", label: "Nanotechnology" },
  { value: "Pets & Animals", label: "Pets & Animals" },
  {
    value: "Professional & Commercial Services",
    label: "Professional & Commercial Services",
  },
  { value: "Real Estate", label: "Real Estate" },
  { value: "Retail", label: "Retail" },
  { value: "Robotics", label: "Robotics" },
  { value: "Safety", label: "Safety" },
  { value: "Security Solutions", label: "Security Solutions" },
  { value: "Household Services", label: "Household Services" },
  { value: "Social Impact", label: "Social Impact" },
  { value: "Social Network", label: "Social Network" },
  { value: "Sports", label: "Sports" },
  { value: "Textiles & Apparel", label: "Textiles & Apparel" },
  { value: "Transportation & Storage", label: "Transportation & Storage" },
  { value: "Travel & Tourism", label: "Travel & Tourism" },
  { value: "Advertising", label: "Advertising" },
  { value: "Agriculture", label: "Agriculture" },
  { value: "Others", label: "Others" },
  { value: "Logistics", label: "Logistics" },
  { value: "Airport Operations", label: "Airport Operations" },
  { value: "Waste Management", label: "Waste Management" },
  { value: "Passenger Experience", label: "Passenger Experience" },
  { value: "Biotechnology", label: "Biotechnology" },
  { value: "Indic Language Services", label: "Indic Language Services" },
];
const subIndustryOptions = [
  { value: "Marketing", label: "Marketing" },
  {
    value: "Aeronautics Aerospace & Defense",
    label: "Aeronautics Aerospace & Defense",
  },
  { value: "AI", label: "AI" },
  { value: "Analytics", label: "Analytics" },
  { value: "Animation", label: "Animation" },
  { value: "AR VR", label: "AR VR" },
  {
    value: "Architecture Interior Design",
    label: "Architecture Interior Design",
  },
  { value: "Art & Photography", label: "Art & Photography" },
  { value: "Automotive", label: "Automotive" },
  { value: "Chemicals", label: "Chemicals" },
  {
    value: "Telecommunication & Networking",
    label: "Telecommunication & Networking",
  },
  { value: "Computer Vision", label: "Computer Vision" },
  { value: "Construction", label: "Construction" },
  { value: "Dating Matrimonial", label: "Dating Matrimonial" },
  { value: "Design", label: "Design" },
  { value: "Education", label: "Education" },
  { value: "Non-Renewable Energy", label: "Non-Renewable Energy" },
  { value: "Green Technology", label: "Green Technology" },
  { value: "Enterprise Software", label: "Enterprise Software" },
  { value: "Events", label: "Events" },
  { value: "Fashion", label: "Fashion" },
  { value: "Finance Technology", label: "Finance Technology" },
  { value: "Food & Beverage", label: "Food & Beverage" },
  { value: "Healthcare & Lifesciences", label: "Healthcare & Lifesciences" },
  { value: "Human Resources", label: "Human Resources" },
  { value: "Internet of Things", label: "Internet of Things" },
  { value: "IT Services", label: "IT Services" },
  { value: "Media & Entertainment", label: "Media & Entertainment" },
  { value: "Nanotechnology", label: "Nanotechnology" },
  { value: "Pets & Animals", label: "Pets & Animals" },
  {
    value: "Professional & Commercial Services",
    label: "Professional & Commercial Services",
  },
  { value: "Real Estate", label: "Real Estate" },
  { value: "Retail", label: "Retail" },
  { value: "Robotics", label: "Robotics" },
  { value: "Safety", label: "Safety" },
  { value: "Security Solutions", label: "Security Solutions" },
  { value: "Household Services", label: "Household Services" },
  { value: "Social Impact", label: "Social Impact" },
  { value: "Social Network", label: "Social Network" },
  { value: "Sports", label: "Sports" },
  { value: "Textiles & Apparel", label: "Textiles & Apparel" },
  { value: "Transportation & Storage", label: "Transportation & Storage" },
  { value: "Travel & Tourism", label: "Travel & Tourism" },
  { value: "Advertising", label: "Advertising" },
  { value: "Agriculture", label: "Agriculture" },
  { value: "Others", label: "Others" },
  { value: "Logistics", label: "Logistics" },
  { value: "Airport Operations", label: "Airport Operations" },
  { value: "Waste Management", label: "Waste Management" },
  { value: "Passenger Experience", label: "Passenger Experience" },
  { value: "Biotechnology", label: "Biotechnology" },
  { value: "Indic Language Services", label: "Indic Language Services" },
];
// const genders = [
//   {
//     isoCode: "male",
//     name: "Male",
//   },
//   {
//     isoCode: "female",
//     name: "Female",
//   },

//   {
//     isoCode: "Other",
//     name: "Other",
//   },
//   {
//     isoCode: "Prefer not to disclose",
//     name: "Prefer not to disclose",
//   },
// ];
const genders = [
  {
    value: "Male",
    label: "Male",
  },
  {
    value: "Female",
    label: "Female",
  },

  {
    value: "Other",
    label: "Other",
  },
  {
    value: "Prefer not to disclose",
    label: "Prefer not to disclose",
  },
];
const specializationOptions = [
  {
    value: "Product Development and Technology",
    label: "Product Development and Technology",
  },
  { value: "Customer Acquisition", label: "Customer Acquisition" },
  { value: "Fundraising", label: "Fundraising" },
  { value: "Branding & Marketing", label: "Branding & Marketing" },
  { value: "Compliance & Legal", label: "Compliance & Legal" },
  { value: "Human Resource Management", label: "Human Resource Management" },
];
const subSpecializationOptions = [
  {
    value: "Product Development and Technology",
    label: "Product Development and Technology",
  },
  { value: "Customer Acquisition", label: "Customer Acquisition" },
  { value: "Fundraising", label: "Fundraising" },
  { value: "Branding & Marketing", label: "Branding & Marketing" },
  { value: "Compliance & Legal", label: "Compliance & Legal" },
  { value: "Human Resource Management", label: "Human Resource Management" },
];

const preferredOptions = [
  { value: "Ideation", label: "Ideation" },
  { value: "Validation", label: "Validation" },
  { value: "Early Traction", label: "Early Traction" },
  { value: "Scaling", label: "Scaling" },
  // { value: "Corporate", label: "Corporate" },
];
const keywords = [
  {
    value: "lorem ipsum",
    label: "lorem ipsum",
  },
  // { value: "Customer Acquisition", label: "Customer Acquisition" },
  // { value: "Fundraising", label: "Fundraising" },
  // { value: "Branding & Marketing", label: "Branding & Marketing" },
  // { value: "Compliance & Legal", label: "Compliance & Legal" },
  // { value: "Human Resource Management", label: "Human Resource Management" },
];

const useStyles = makeStyles((theme) => ({
  button: {
    // #47558
    leftbutton: {
      marginRight: theme.spacing(1),
      backgroundColor: "#3AC2D7",
      color: "#fff",
      width: "150px",
    },
    rightbutton: {
      marginRight: "8px",
      backgroundColor: "#f4f4f4",
      border: "1 solid #000",
      width: "150px",
    },
  },
  textFieldRoot: {
    // // this will be applied when hovered (input text color change)
    // "&:hover": {
    //   color: theme.palette.secondary.main,
    // },
    // // this will applied when hovered (input border color change)
    // "&:hover $textFieldNotchedOutline": {
    //   borderColor: theme.palette.secondary.main
    // },
    // this will be applied when focused (input border color change)
    "&$textFieldFocused $textFieldNotchedOutline": {
      borderColor: "orange",
    },
  },
}));

const customStyles = {
  option: (provided, state) => ({
    ...provided,

    textAlign: "left",
  }),
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
  // container: (provided, state) => ({
  //   ...provided,
  //   marginTop: 50,
  // }),
  // valueContainer: (provided, state) => ({
  //   ...provided,
  //   overflow: "visible",
  // }),
  // placeholder: (base, state) => ({
  //   ...base,
  //   position: "absolute",
  //   top:
  //     state.hasValue ||
  //     state.selectProps.inputValue ||
  //     state.selectProps.isFocused
  //       ? "-120%"
  //       : "0%",
  //   transition: "top 0.2s, font-size 0.2s",
  //   fontSize:
  //     (state.hasValue ||
  //       state.selectProps.inputValue ||
  //       state.selectProps.isFocused) &&
  //     14,
  // }),
};

const customStylesCountry = {
  option: (provided, state) => ({
    ...provided,

    textAlign: "left",
  }),

  container: (provided, state) => ({
    ...provided,
    marginTop: 40,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    overflow: "visible",
  }),
  placeholder: (base, state) => ({
    ...base,
    position: "absolute",
    top:
      state.hasValue ||
      state.selectProps.inputValue ||
      state.selectProps.isFocused
        ? "-120%"
        : "0%",
    transition: "top 0.2s, font-size 0.2s",
    fontSize:
      (state.hasValue ||
        state.selectProps.inputValue ||
        state.selectProps.isFocused) &&
      14,
    marginLeft:
      (state.hasValue ||
        state.selectProps.inputValue ||
        state.selectProps.isFocused) &&
      -10,
  }),
};

function getSteps() {
  return [
    "MENTOR DETAILS",
    "MENTOR CONTACT",
    "MENTORSHIP REQUIREMENTS",
    "MENTOR PREFERENCES",
    "DOCUMENT UPLOAD",
    // "DISCLAIMER",
  ];
}
let regionNames = "";
try {
  regionNames = new Intl.DisplayNames(["en"], { type: "region" });
} catch (error) {}

const MentorFillupForm = (props) => {
  const predefinedIndustryArray = [];
  const predefinedSubIndustryArray = [];
  const predefinedSpecializationArray = [];
  const predefinedSubSpecializationArray = [];
  const predefinedStageArray = [];
  const newCountryArray = [];
  const newStateArray = [];
  const newCityArray = [];

  const [wordCounter, setWordCounter] = useState(0);
  const [percentageData, setPercentageData] = useState(0);
  const [draftApplicationStatus, setDraftApplicationStatus] = useState("");
  const [alreadySelectedState, stateAlreadySelectedState] = useState(
    props.location.state && props.location.state.state
  );
  const [menuopen, setmenuopen] = useState(false);
  const prefilledGenderObject = {
    value:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.gender
        : "",
    label:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.gender
        : "",
  };

  const prefilledCountryObject = {
    value: props.location.state && props.location.state.country,

    label: props.location.state && props.location.state.country_name,
  };

  const prefilledStateObject = {
    value: props.location.state && props.location.state.state,

    label: props.location.state && props.location.state.state_name,
  };

  const prefilledCityObject = {
    value: props.location.state && props.location.state.city,

    label: props.location.state && props.location.state.city,
  };

  const capitalizeFirstLetter = (text) => {
    try {
      if (text || text != null || text != "" || text != "null") {
        return text.charAt(0).toUpperCase() + text.slice(1);
      } else return "";
    } catch (error) {
      return "";
    }
  };
  useEffect(() => {
    // alert("action"+action)
    if (action === "EditApplication" || action === "VERIFIED") {
      // const predefinedIndustryArray = [];
      props.location.state.industry.map((item) => {
        const newObject = {
          value: item,
          label: item,
        };

        predefinedIndustryArray.push(newObject);
        setPrefillIndustry(predefinedIndustryArray);
      });

      props.location.state.subindustry.map((item) => {
        const newObject = {
          value: item,
          label: item,
        };

        predefinedSubIndustryArray.push(newObject);
        setPrefillIndustry(predefinedSubIndustryArray);
      });

      // const predefinedSpecializationArray = [];
      props.location.state.specialization.map((item) => {
        const newObject = {
          value: item,
          label: item,
        };

        predefinedSpecializationArray.push(newObject);
        setPrefillSpecial(predefinedSpecializationArray);
      });

      props.location.state.subspecialization.map((item) => {
        const newObject = {
          value: item,
          label: item,
        };

        predefinedSubSpecializationArray.push(newObject);
        setPrefillSpecial(predefinedSubSpecializationArray);
      });

      // const predefinedStageArray = [];
      props.location.state.preferredStage.map((item) => {
        const newObject = {
          value: item,
          label: item,
        };

        predefinedStageArray.push(newObject);
        setPrefillStage(predefinedStageArray);
      });
      // generatePercentageData();
    }
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });

    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
    City.getCitiesOfState("IN", alreadySelectedState).map((item) => {
      const newObject = {
        value: item.name,
        label: item.name,
      };

      newCityArray.push(newObject);
      setNewCityOptions(newCityArray);
    });

    // calling view applicaiton service
    if (
      localStorage.getItem("SavedLoggedInData") &&
      localStorage.getItem("loggedIn") === "true"
    ) {
      const params = {
        id: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      };
      api
        .POST(`${VIEW_MENTOR_APPLICATION_DATA}`, params)
        .then((response) => {
          const { data, status } = response || {};
          if (status === 200) {
            if (response.data.data) {
              const responseData = response.data.data;
              setDraftApplicationStatus(responseData.applicationStatus);
              if (responseData.country != "IN") {
                setFormData((user) => {
                  return {
                    ...user,
                    ["city_name"]: responseData.city,
                  };
                });
              }
              setFormData((user) => {
                const industryDataDraft = [];
                const subIndustryDraft = [];
                const functionDraft = [];
                const subspecializationDraft = [];
                const preferedStageDraft = [];

                responseData.industry.map((item) => {
                  const industryObject = {
                    value: item,
                    label: item,
                  };
                  industryDataDraft.push(industryObject);
                });

                responseData.subindustry.map((item) => {
                  const subindustryObject = {
                    value: item,
                    label: item,
                  };
                  subIndustryDraft.push(subindustryObject);
                });

                responseData.specialization.map((item) => {
                  const functionObject = {
                    value: item,
                    label: item,
                  };
                  functionDraft.push(functionObject);
                });

                responseData.subspecialization.map((item) => {
                  const subfunctionObject = {
                    value: item,
                    label: item,
                  };
                  subspecializationDraft.push(subfunctionObject);
                });
                responseData.preferredStage.map((item) => {
                  const preferedstageObject = {
                    value: item,
                    label: item,
                  };
                  preferedStageDraft.push(preferedstageObject);
                });

                setPhoneValue(responseData.phone_number);
                setTempPhoneValue(responseData.phone_number);
                return {
                  ...user,
                  //  designation: responseData.designation,
                  //  appLindin_url: responseData.appLindin_url,
                  //  state_name: responseData.state_name,
                  //  state: {
                  //    value: responseData.state,
                  //    label: responseData.state_name,
                  //  },
                  //  startupwebsite: responseData.startupwebsite,
                  //  startup_video_url: responseData.startup_video_url,
                  //  curret_revenue: responseData.curret_revenue,
                  //  offered_startup: responseData.offered_startup,
                  //  problem_solved: responseData.problem_solved,
                  //  whyneedMentorship: responseData.whyneedMentorship,
                  //  expected_outcome: responseData.expected_outcome,
                  //  contact_no: responseData.contact_no,
                  //  industrydata: industryDataDraft,
                  //  subindustry: subIndustryDraft,
                  //  preferedfuncsupport: functionDraft,
                  //  subspecialization: subspecializationDraft,
                  organization_name: responseData.organization_name,
                  current_designation: responseData.current_designation,
                  phone_number: responseData.phone_number,
                  gender: {
                    value: capitalizeFirstLetter(responseData.gender),
                    label: capitalizeFirstLetter(responseData.gender),
                  },
                  country: {
                    value: responseData.country,
                    label: responseData.country_name,
                  },
                  country_name: responseData.country_name,
                  state: {
                    value: responseData.state,
                    label: responseData.state_name,
                  },
                  state_name: responseData.state_name,
                  city_name: responseData.city,
                  city: {
                    value: responseData.city,
                    label: responseData.city,
                  },

                  mentoratstartup: responseData.mentoratstartup,
                  hoursperweek: responseData.hoursperweek,
                  industry: industryDataDraft,
                  subindustry: subIndustryDraft,
                  specialization: functionDraft,
                  subspecialization: subspecializationDraft,
                  preferredStage: preferedStageDraft,
                  linkedinurl: responseData.linkedinurl,
                  uploadResume: responseData.uploadResume,
                  personalblogurl: responseData.personalblogurl,
                  shortDesription: responseData.shortDesription,
                };
              });
            }
            setViewApplicationData(response.data.data);
            // generatePercentageData();
          } else {
          }
        })
        .catch((e) => {});
    } else {
    }
  }, []);

  const {
    registerMentor,
    getPredefineOptionsList,
    getPredefineOptions,
    savedraftMentor,
  } = props;

  const history = useHistory();
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [skippedSteps, setSkippedSteps] = useState([]);
  const [industry, setIndustry] = useState([]);
  const [subindustry, setSubIndustry] = useState([]);
  const [specialization, setSpecialization] = useState([]);
  const [subspecialization, setSubSpecialization] = useState([]);
  const [preferredStage, setPreferredStage] = useState([]);
  const [optionSelected, setOptionSelected] = useState(null);
  const [showSubmitCohort, setShowSubmitCohort] = useState(false);
  const [submitFormData, setSubmitFormData] = useState({});
  const [action, setAction] = useState(props.location.action);
  const [selectedOtherCity, setSelectedOtherCity] = useState(
    props.location.action === "EditApplication"
      ? props.location.state && props.location.state.city_name
      : ""
  );
  const [prefillIndustry, setPrefillIndustry] = useState(
    predefinedIndustryArray
  );
  const [prefillSubIndustry, setPrefillSubIndustry] = useState(
    predefinedSubIndustryArray
  );
  const [prefillSpecial, setPrefillSpecial] = useState(
    predefinedSpecializationArray
  );
  const [prefillSubSpecial, setPrefillSubSpecial] = useState(
    predefinedSubSpecializationArray
  );
  const [prefillStage, setPrefillStage] = useState(predefinedStageArray);
  const [genderOption, setGender] = useState(null);
  const [prefilledGender, setPrefilledGender] = useState(prefilledGenderObject);
  const [prefilledCountry, setPrefilledCountry] = useState(
    prefilledCountryObject
  );

  const [prefilledState, setPrefilledState] = useState(prefilledStateObject);
  const [prefilledCity, setPrefilledCity] = useState(
    prefilledCityObject

    // props.location.state.city
  );
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCityOptions, setNewCityOptions] = useState(null);

  // const [isMobile, setIsMobile] = useState(false)
  const [phonevalue, setPhoneValue] = useState(
    props.location.action === "EditApplication"
      ? props.location.state && props.location.state.phone_number
      : ""
  );
  const [tempPhoneValue, setTempPhoneValue] = useState(
    props.location.action === "EditApplication"
      ? props.location.state && props.location.state.phone_number
      : ""
  );
  // const tempPhoneValue = props.location.action === "EditApplication"
  // ? props.location.state && props.location.state.phone_number
  // : ""
  const [selectedCountry, setSelectedCountry] = useState(
    props.location.action === "EditApplication"
      ? props.location.state && props.location.state.country.toLowerCase()
      : "in"
  );
  const [viewApplicationData, setViewApplicationData] = useState();

  const [isMobile, setIsMobile] = useState(false);
  const { innerWidth: width, innerHeight: height } = window;

  const [errorMessagePurpose, setErrorMessagePurpose] = useState(
    "*Please Enter the purpose"
  );
  const [errorVisible7, SetErrorVisible7] = useState(false);
  const [wordLimit, setWordlimit] = useState();

  const [wordCounter2, setWordCounter2] = useState(0);
  const [errorMessagePurpose2, setErrorMessagePurpose2] = useState(
    "*Please Enter the purpose"
  );
  const [errorVisible8, SetErrorVisible8] = useState(false);
  const [wordLimit2, setWordlimit2] = useState();

  // const [windowDimensions, setWindowDimensions] = useState(window.getWindowDimensions());
  // useEffect(() => {
  //   function handleResize() {
  //     let dimension = window.getWindowDimensions()
  //     setWindowDimensions(window.getWindowDimensions());
  //     if (window.innerWidth < 720) {
  //       setIsMobile(true)
  //     }
  //     else
  //     setIsMobile(false)
  //   }

  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);
  // const handleResize = () => {
  //   if (window.innerWidth < 720) {
  //       setIsMobile(true)
  //   } else {
  //       setIsMobile(false)
  //   }
  // }
  // useEffect(() => {
  //   window.addEventListener("resize", handleResize)
  // })
  // const handleGender = (genderOption) => {
  //   setGender(genderOption);
  // };

  const assignValue = {
    full_name:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.applicant_name
        : localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData"))
        ? JSON.parse(localStorage.getItem("SavedLoggedInData")).applicant_name
        : "",
    uploadProfilePic: null,
    country:
      props.location.action === "EditApplication" ? prefilledCountry : "",
    country_name:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.country_name
        : "",
    // gender_name:"",
    gender: props.location.action === "EditApplication" ? prefilledGender : "",
    // gender:
    //   props.location.action === "EditApplication"
    //     ? props.location.state && props.location.state.gender
    //     : "",
    email_id:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.email
        : localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData"))
        ? JSON.parse(localStorage.getItem("SavedLoggedInData")).email
        : "",
    phone_number:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.phone
        : localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData"))
        ? JSON.parse(localStorage.getItem("SavedLoggedInData")).phone
        : "",
    state: props.location.action === "EditApplication" ? prefilledState : "",
    state_name:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.state_name
        : "",
    city: props.location.action === "EditApplication" ? prefilledCity : "",
    // city_name:
    //   props.location.action === "EditApplication" ? selectedOtherCity : "",
    city_name:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.country == "IN"
          ? selectedOtherCity
          : props.location.state.city
        : "",
    organization_name:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.organization_name
        : "",
    current_designation:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.current_designation
        : "",
    mentoratstartup:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.mentoratstartup
        : "",
    hoursperweek:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.hoursperweek
        : "",
    linkedinurl:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.linkedinurl
        : "",
    personalblogurl:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.personalblogurl
        : "",
    uploadResume:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.uploadResume
        : null,
    disclaimer: false,
    industry:
      props.location.action === "EditApplication"
        ? // ? props.location.state && props.location.state.industry
          prefillIndustry
        : // prefillIndustry
          "",
    subindustry:
      props.location.action === "EditApplication" ? prefillSubIndustry : "",
    specialization:
      props.location.action === "EditApplication"
        ? // ? props.location.state && props.location.state.specialization
          prefillSpecial
        : "",
    subspecialization:
      props.location.action === "EditApplication" ? prefillSubSpecial : "",
    preferredStage:
      props.location.action === "EditApplication"
        ? // ? props.location.state && props.location.state.preferredStage
          prefillStage
        : "",
    keywords: [],
    shortDesription:
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.shortDesription
        : "",
  };
  const [defaultFormData, setDefaultFormData] = useState(assignValue);

  //  const defaultFormData="";
  useEffect(() => {
    // if(action==="EditApplication"){
    //   const assignValue = {
    //     full_name:
    //     props.data &&
    //     props.data
    //         ? props.data.applicant_name
    //         : "",
    //     uploadProfilePic: null,
    //     country: "",
    //     country_name: "",
    //     // gender_name:"",
    //     gender: "",
    //     email_id: props.data&& props.data? props.data.email: "",
    //     phone_number: props.data && props.data? props.data.phone : "",
    //     state: "",
    //     state_name: "",
    //     city: props.data &&props.data?props.data.city:"",
    //     organization_name:props.data &&props.data?props.data.organization_name:"",
    //     current_designation: props.data &&props.data?props.data.current_designation:"",
    //     mentoratstartup: "",
    //     hoursperweek: "",
    //     linkedinurl: "",
    //     personalblogurl: "",
    //     uploadResume: null,
    //     disclaimer: false,
    //     industry: [],
    //     subindustry: [],
    //     specialization: [],
    //     subspecialization: [],
    //     preferredStage: [],
    //     keywords: [],
    //     shortDesription: "",
    //   };
    //   setDefaultFormData(assignValue)
    // }else{
    //  const assignValue = {
    //     full_name:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData"))
    //         ? JSON.parse(localStorage.getItem("SavedLoggedInData")).applicant_name
    //         : "",
    //     uploadProfilePic: null,
    //     country: "",
    //     country_name: "",
    //     // gender_name:"",
    //     gender: "",
    //     email_id:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData"))
    //         ? JSON.parse(localStorage.getItem("SavedLoggedInData")).email
    //         : "",
    //     phone_number:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData"))
    //         ? JSON.parse(localStorage.getItem("SavedLoggedInData")).phone
    //         : "",
    //     state: "",
    //     state_name: "",
    //     city: "",
    //     organization_name: "",
    //     current_designation: "",
    //     mentoratstartup: "",
    //     hoursperweek: "",
    //     linkedinurl: "",
    //     personalblogurl: "",
    //     uploadResume: null,
    //     disclaimer: false,
    //     industry: [],
    //     subindustry: [],
    //     specialization: [],
    //     subspecialization: [],
    //     preferredStage: [],
    //     keywords: [],
    //     shortDesription: "",
    //   };
    //    setDefaultFormData(assignValue)
    // }
  }, []);
  const [error, setError] = useState({});

  const [hasInvalidSubmitOccurred, setHasInvalidSubmitOccurred] =
    useState(false);
  const [formData, setFormData] = useState(defaultFormData);
  const [profileExistingImg, setProfileExistingImg] = useState();
  const [predefineOptionsList, setPredefineOptionsList] = useState();
  const [initialPercentage, setInitialPercentage] = useState(0);
  // const [disclaimerChecked, setDisclaimerChecked] = useState(false);
  const [loginData, setLoginData] = useState();
  const [formPercentageValue, setFormPercentageValue] = useState(0);
  const [focused, setFocused] = useState(false);
  const [statefocused, setStateFocused] = useState(false);
  const [cityfocused, setCityFocused] = useState(false);
  const [genderfocused, setGenderFocused] = useState(false);
  const [formPercentage, setFormPercentage] = useState({
    fullName: {
      value: true,
      weightage: 6,
    },
    currentOrganization: {
      value: false,
      weightage: 7,
    },
    current_designation: {
      value: false,
      weightage: 7,
    },
    email: {
      value: false,
      weightage: 3.75,
    },
    phNumber: {
      value: false,
      weightage: 3.25,
    },
    gender: {
      value: false,
      weightage: 3.25,
    },
    country: {
      value: false,
      weightage: 3.25,
    },
    countryState: {
      value: false,
      weightage: 3.25,
    },
    city: {
      value: false,
      weightage: 3.25,
    },
    reasonForMentorship: {
      value: false,
      weightage: 10,
    },
    hoursDedicated: {
      value: false,
      weightage: 10,
    },
    industry: {
      value: false,
      weightage: 4,
    },
    industryKeywords: {
      value: false,
      weightage: 4,
    },
    function: {
      value: false,
      weightage: 4,
    },
    functionKeyword: {
      value: false,
      weightage: 4,
    },
    stage: {
      value: false,
      weightage: 4,
    },
    resumeUpload: {
      value: false,
      weightage: 10,
    },
    termsConfirmation: {
      value: false,
      weightage: 10,
    },
  });
  const generatePercentageData = (params) => {
    let step0output;
    if (
      formData &&
      formData.organization_name !== "" &&
      formData &&
      formData.current_designation !== ""
    ) {
      step0output =
        (formPercentage.fullName.value === true
          ? formPercentage.fullName.weightage
          : 0) +
        (formData && formData.organization_name.length > 0
          ? formPercentage.currentOrganization.weightage
          : 0) +
        (formData && formData.current_designation.length > 0
          ? formPercentage.current_designation.weightage
          : 0);
      if (activeStep == 0) {
        // output = step0output
        setFormPercentageValue(step0output);
      }
    }
    // else if((formData && formData.organization_name === "") || (formData && formData.current_designation === ""))
    // {
    //   step0output =   (formPercentage.fullName.value === true
    //     ? formPercentage.fullName.weightage
    //     : 0) +
    //     (formData && formData.organization_name.length > 0
    //     ? formPercentage.currentOrganization.weightage
    //     : 0) +
    //   (formData && formData.current_designation.length > 0
    //     ? formPercentage.current_designation.weightage
    //     : 0);
    //     if(activeStep == 0) {
    //       // output = step0output
    //       setFormPercentageValue(step0output);
    //     }
    // }
    let step1output =
      formPercentage.email.weightage +
      (phonevalue !== "" ? formPercentage.phNumber.weightage : 0) +
      (formData.gender !== "" ? formPercentage.gender.weightage : 0) +
      (formData.country !== "" ? formPercentage.country.weightage : 0) +
      (formData.state.value !== ""
        ? formPercentage.countryState.weightage
        : 0) +
      (formData.city.value !== "" ? formPercentage.city.weightage : 0);

    let step2output =
      (formData.mentoratstartup !== ""
        ? formPercentage.reasonForMentorship.weightage
        : 0) +
      (formData.hoursperweek !== ""
        ? formPercentage.hoursDedicated.weightage
        : 0);

    let step3output =
      (formData.industry && formData.industry.length > 0
        ? formPercentage.industry.weightage
        : 0) +
      (formData.subindustry && formData.subindustry.length > 0
        ? formPercentage.industryKeywords.weightage
        : 0) +
      (formData.specialization && formData.specialization.length > 0
        ? formPercentage.function.weightage
        : 0) +
      (formData.subspecialization && formData.subspecialization.length > 0
        ? formPercentage.functionKeyword.weightage
        : 0) +
      (formData.preferredStage && formData.preferredStage.length > 0
        ? formPercentage.stage.weightage
        : 0) +
      ((formData.subindustry && formData.subindustry.length == 10) ||
      (formData.subspecialization && formData.subspecialization.length == 10)
        ? 4
        : 0);

    let step4output =
      (formData.disclaimer === true
        ? formPercentage.termsConfirmation.weightage
        : 0) +
      (formData.uploadResume !== "" &&
      formData.uploadResume !== undefined &&
      formData.uploadResume !== null
        ? formPercentage.resumeUpload.weightage
        : 0);

    if (activeStep == 1 && params !== "countryChange") {
      setFormPercentageValue(step0output + step1output);
    } else if (activeStep == 2) {
      setFormPercentageValue(step0output + step1output + step2output);
    } else if (activeStep == 3) {
      setFormPercentageValue(
        step0output + step1output + step2output + step3output
      );
    } else if (activeStep == 4) {
      setFormPercentageValue(
        step0output + step1output + step2output + step3output + step4output
      );
    }
    if (params == 0) {
      setFormPercentageValue(step0output);
    }
    if (params == 1) {
      step0output =
        (formPercentage.fullName.value === true
          ? formPercentage.fullName.weightage
          : 0) +
        (formData && formData.organization_name.length > 0
          ? formPercentage.currentOrganization.weightage
          : 0) +
        (formData && formData.current_designation.length > 0
          ? formPercentage.current_designation.weightage
          : 0);
      setFormPercentageValue(step0output);
    }
    if (params == 20) {
      setFormPercentageValue(20);
    }
    if (params == 10) {
      setFormPercentageValue(10);
    }
    if (params == -10) {
      setFormPercentageValue(0);
    }
    if (params == "countryChange") {
      //   if(params == "India")
      // {
      //   // setFormPercentageValue(formPercentageValue-7);
      //   // setFormPercentageValue(step0output+step1output-12);

      // }
      // //  else
      step1output =
        formPercentage.email.weightage +
        (phonevalue !== "" ? formPercentage.phNumber.weightage : 0) +
        (formData.gender.value !== "" || formData.gender.value !== null
          ? formPercentage.gender.weightage
          : 0) +
        (formData.country.value !== "" || formData.country.value !== null
          ? formPercentage.country.weightage
          : 0) +
        (formData.state.value !== "" || formData.state.value !== null
          ? formPercentage.countryState.weightage
          : 0) +
        (formData.city.value !== "" || formData.city.value !== null
          ? formPercentage.city.weightage
          : 0);
      setFormPercentageValue(28);
    }
  };
  useEffect(() => {
    if (
      formData &&
      formData.current_designation !== "" &&
      formData &&
      formData.organization_name !== ""
    ) {
      generatePercentageData(20);
    } else if (
      formData &&
      formData.current_designation === "" &&
      formData &&
      formData.organization_name === ""
    ) {
      generatePercentageData(-10);
    } else if (
      formData &&
      formData.current_designation !== "" &&
      formData &&
      formData.organization_name === ""
    ) {
      generatePercentageData(10);
    } else if (
      formData &&
      formData.current_designation === "" &&
      formData &&
      formData.organization_name !== ""
    ) {
      generatePercentageData(10);
    }
  }, [formData]);
  useEffect(() => {
    // if (activeStep === 0) {
    //   if (formData.organization_name !== "") {
    //     setFormPercentage((prevState) => ({
    //       ...prevState,
    //       currentOrganization: {
    //         ...prevState.currentOrganization,
    //         value: true,
    //       },
    //     }));
    //     generatePercentageData();
    //   }
    //   else{
    //     setFormPercentage((prevState) => ({
    //       ...prevState,
    //       currentOrganization: {
    //         ...prevState.currentOrganization,
    //         value: false,
    //       },
    //     }));
    //     generatePercentageData(1);
    //   }
    //   if (formData.current_designation !== "") {
    //     setFormPercentage((prevState) => ({
    //       ...prevState,
    //       current_designation: {
    //         ...prevState.current_designation,
    //         value: true,
    //       },
    //     }));
    //     generatePercentageData();
    //   }
    //   else{

    //     setFormPercentage((prevState) => ({
    //       ...prevState,
    //       current_designation: {
    //         ...prevState.current_designation,
    //         value: false,
    //       },
    //     }));
    //     generatePercentageData(1);
    //   }
    // }
    if (activeStep === 1) {
      setFormPercentage((prevState) => ({
        ...prevState,
        email: {
          ...prevState.email,
          value: true,
        },
      }));
      if (phonevalue !== "") {
        setFormPercentage((prevState) => ({
          ...prevState,
          phNumber: {
            ...prevState.phNumber,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          phNumber: {
            ...prevState.phNumber,
            value: false,
          },
        }));
        // generatePercentageData();
      }
      if (formData.gender.value !== "" && formData.gender.value !== null) {
        setFormPercentage((prevState) => ({
          ...prevState,
          gender: {
            ...prevState.gender,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          gender: {
            ...prevState.gender,
            value: false,
          },
        }));
        // generatePercentageData();
      }
      if (formData.country.value !== "" && formData.country.value !== null) {
        setFormPercentage((prevState) => ({
          ...prevState,
          country: {
            ...prevState.country,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          country: {
            ...prevState.country,
            value: false,
          },
        }));
        // generatePercentageData();
      }
      if (formData.state.value !== "" && formData.state.value !== null) {
        setFormPercentage((prevState) => ({
          ...prevState,
          countryState: {
            ...prevState.countryState,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          countryState: {
            ...prevState.countryState,
            value: false,
          },
        }));
        // generatePercentageData();
      }

      if (formData.city.value !== "" && formData.city.value !== null) {
        setFormPercentage((prevState) => ({
          ...prevState,
          city: {
            ...prevState.city,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          city: {
            ...prevState.city,
            value: false,
          },
        }));
        // generatePercentageData();
      }
    }
    if (activeStep === 2) {
      if (formData.mentoratstartup !== "") {
        setFormPercentage((prevState) => ({
          ...prevState,
          reasonForMentorship: {
            ...prevState.reasonForMentorship,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          reasonForMentorship: {
            ...prevState.reasonForMentorship,
            value: false,
          },
        }));
        generatePercentageData();
      }
      if (formData.hoursperweek !== "") {
        setFormPercentage((prevState) => ({
          ...prevState,
          hoursDedicated: {
            ...prevState.hoursDedicated,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          hoursDedicated: {
            ...prevState.hoursDedicated,
            value: true,
          },
        }));
        generatePercentageData();
      }
    }
    if (activeStep === 3) {
      if (formData.industry && formData.industry.length > 0) {
        setFormPercentage((prevState) => ({
          ...prevState,
          industry: {
            ...prevState.industry,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          industry: {
            ...prevState.industry,
            value: false,
          },
        }));
        generatePercentageData();
      }
      if (formData.subindustry && formData.subindustry.length > 0) {
        setFormPercentage((prevState) => ({
          ...prevState,
          industryKeywords: {
            ...prevState.industryKeywords,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          industryKeywords: {
            ...prevState.industryKeywords,
            value: false,
          },
        }));
        generatePercentageData();
      }
      if (formData.specialization && formData.specialization.length > 0) {
        setFormPercentage((prevState) => ({
          ...prevState,
          function: {
            ...prevState.function,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          function: {
            ...prevState.function,
            value: false,
          },
        }));
        generatePercentageData();
      }
      if (formData.subspecialization && formData.subspecialization.length > 0) {
        setFormPercentage((prevState) => ({
          ...prevState,
          functionKeyword: {
            ...prevState.functionKeyword,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          functionKeyword: {
            ...prevState.functionKeyword,
            value: false,
          },
        }));
        generatePercentageData();
      }
      if (formData.preferredStage && formData.preferredStage.length > 0) {
        setFormPercentage((prevState) => ({
          ...prevState,
          stage: {
            ...prevState.stage,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          stage: {
            ...prevState.stage,
            value: false,
          },
        }));
        generatePercentageData();
      }
    }
    if (activeStep === 4) {
      if (formData.disclaimer) {
        setFormPercentage((prevState) => ({
          ...prevState,
          termsConfirmation: {
            ...prevState.termsConfirmation,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          termsConfirmation: {
            ...prevState.termsConfirmation,
            value: false,
          },
        }));
        generatePercentageData();
      }
      if (
        formData.resumeUpload !== undefined &&
        formData.resumeUpload !== "" &&
        formData.resumeUpload !== null
      ) {
        setFormPercentage((prevState) => ({
          ...prevState,
          resumeUpload: {
            ...prevState.resumeUpload,
            value: true,
          },
        }));
        generatePercentageData();
      } else {
        setFormPercentage((prevState) => ({
          ...prevState,
          resumeUpload: {
            ...prevState.resumeUpload,
            value: false,
          },
        }));
        generatePercentageData();
      }
    }
  }, [activeStep]);
  useEffect(() => {
    getPredefineOptionsList();

    const dropdownList = getPredefineOptions?.industry_options.shift();
    const dropdownList2 = getPredefineOptions?.functional_areas.shift();
    const dropdownList4 = getPredefineOptions?.sub_industry.shift();
    const dropdownList5 = getPredefineOptions?._specialisation.shift();
    setPredefineOptionsList(getPredefineOptions);
  }, []);
  useEffect(() => {
    setPredefineOptionsList(getPredefineOptions);
  }, [getPredefineOptions]);
  useEffect(() => {
    generatePercentageData();
  }, [formData]);
  useEffect(() => {
    try {
      let value = localStorage.getItem("SavedLoggedInData");
      let data = JSON.parse(localStorage.getItem("SavedLoggedInData"));
      if (data?.image === null) setProfileExistingImg(hashImage);
      else setProfileExistingImg(data.image);
      setFormData((user) => {
        return {
          ...user,
          ["full_name"]: data.applicant_name,
          ["email_id"]: data.email,
          ["phone_number"]: data.phone,
        };
      });
      // generatePercentageData();
    } catch (error) {}
  }, []);
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };
  // Generate JSX code for error message
  const renderErrorMessage = (name) => {
    return (
      <div style={{ paddingLeft: "0px" }}>
        <div className="login-error-msg">{name}</div>
      </div>
    );
  };
  const handleChange = (selected) => {
    setOptionSelected(selected);
  };

  const onclickShowSubmitCohort = (Id) => {
    // setActivityFellowId(Id);
    setShowSubmitCohort(true);
  };

  const clickOnClose = () => {
    setShowSubmitCohort((x) => !x);
    // getActivityFellow()
  };

  const validateStep1Input = () => {
    const {
      full_name,
      current_designation,
      organization_name,
      uploadProfilePic,
    } = formData;
    const formStatus = FormValidator.validateStep1({
      full_name,
      current_designation,
      organization_name,
      uploadProfilePic,
    });

    const errors = {
      fullname: formStatus.fullname,
      currentDesgnation: formStatus.currentDesgnation,
      orgName: formStatus.orgName,
      uploadProfilePic: formStatus.uploadProfilePic,
    };
    setError(errors);
    return !formStatus.hasErrors;
  };

  const validateStep2Input = () => {
    const { email_id, phone_number, country, state, city, gender, city_name } =
      formData;
    const formStatus = FormValidator.validateStep2({
      email_id,
      phonevalue,
      gender,
      country,
      state,
      city,
      city_name,
    });

    const errors = {
      email_id: formStatus.email_id,
      phonevalue: formStatus.phonevalue,
      gender: formStatus.gender,
      country: formStatus.country,
      state: formStatus.state,
      city: formStatus.city,
      cityName: formStatus.cityName,
    };
    setError(errors);
    return !formStatus.hasErrors;
  };

  const validateStep3Input = () => {
    const { mentoratstartup, hoursperweek } = formData;
    const formStatus = FormValidator.validateStep3({
      mentoratstartup,
      hoursperweek,
    });

    const errors = {
      mentoratstartup: formStatus.mentoratstartup,
      hoursperweek: formStatus.hoursperweek,
    };
    setError(errors);
    return !formStatus.hasErrors;
  };
  const removeFile = (fileType) => {
    if (fileType === "uploadResume") {
      setFormData((user) => {
        return { ...user, ["uploadResume"]: null };
      });
    }
  };

  const validateStep4Input = () => {
    const {
      industry,
      subindustry,
      specialization,
      subspecialization,
      preferredStage,
    } = formData;
    const formStatus = FormValidator.validateStep4({
      industry,
      subindustry,
      specialization,
      subspecialization,
      preferredStage,
    });

    const errors = {
      industry: formStatus.industry,
      subindustry: formStatus.subindustry,
      specialization: formStatus.specialization,
      subspecialization: formStatus.subspecialization,
      preferredStage: formStatus.preferredStage,
    };
    setError(errors);
    return !formStatus.hasErrors;
  };

  const validateStep5Input = () => {
    const {
      linkedinurl,
      uploadResume,
      personalblogurl,
      disclaimer,
      shortDesription,
    } = formData;
    // alert('validateStep5Input '+disclaimer)
    const formStatus = FormValidator.validateStep5({
      linkedinurl,
      uploadResume,
      personalblogurl,
      disclaimer,
      shortDesription,
    });

    const errors = {
      linkedinurl: formStatus.linkedinurl,
      uploadResume: formStatus.uploadResume,
      personalblogurl: formStatus.personalblogurl,
      disclaimer: formStatus.disclaimer,
      shortDesription: formStatus.shortDesription,
    };
    setError(errors);
    return !formStatus.hasErrors;
  };
  const previewProfilePic = (file) => {
    if (FileReader) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          document.getElementById("fileUpload-profile-pic").src = image.src;
        };
      };
    }
  };
  const onBlur = () => {
    if (activeStep === 0) validateStep1Input();
    if (activeStep === 1) validateStep2Input();
    if (activeStep === 2) validateStep3Input();
    if (activeStep === 3) validateStep4Input();
    if (activeStep === 4) validateStep5Input();
  };

  function getStepContent(step) {
    const oncheckedChange = (e) => {
      setFormData((user) => {
        return { ...user, disclaimer: !formData.disclaimer };
      });
      validateStep5Input();
    };

    const testWordLimit = (data) => {
      let value =
        data?.length === 0
          ? 0
          : data
              ?.replace(/(^\s*)|(\s*$)/gi, "")
              ?.replace(/[ ]{2,}/gi, " ")
              ?.split(" ")?.length;
      if (value == 100) {
        setErrorMessagePurpose("Exceeds word limit reached");
        SetErrorVisible7(true);
      } else if (value < 100 && value > 0) {
        SetErrorVisible7(false);
        setErrorMessagePurpose("*Please Enter Mentorship Startup");
      } else if (value == 0) {
        SetErrorVisible7(true);
        document.getElementById("mentoratstartup").value = "";
      } else if (value == 101) {
        setWordCounter(100);
        return value;
      }
      setWordCounter(value);
      return value;
    };

    const testWordLimit2 = (data) => {
      let value =
        data?.length === 0
          ? 0
          : data
              ?.replace(/(^\s*)|(\s*$)/gi, "")
              ?.replace(/[ ]{2,}/gi, " ")
              ?.split(" ")?.length;
      if (value == 200) {
        setErrorMessagePurpose2("Exceeds word limit reached");
        SetErrorVisible8(true);
      } else if (value < 200 && value > 0) {
        SetErrorVisible8(false);
        setErrorMessagePurpose2("*Please Enter Problem Solved by Startup");
      } else if (value == 0) {
        SetErrorVisible8(true);
        document.getElementById("shortDesription").value = "";
      } else if (value == 201) {
        setWordCounter2(200);
        return value;
      }
      setWordCounter2(value);
      return value;
    };

    const handleInputChange = (e) => {
      // generatePercentageData();
      try {
        if (e.target.name === "uploadResume") {
          if (e.target.files[0].type == "application/pdf") {
            setFormData((user) => {
              return { ...user, [e.target.name]: e.target.files[0] };
            });
            const newFormData = {
              ...formData,
              [e.target.name]: e.target.files[0],
            };

            // setAppliedFormData(newFormData);
            addDraftData(newFormData, "nextdraftbutton");
          } else {
            toast.error("File format is not supported");
          }
        } else if (e.target.name === "uploadProfilePic") {
          if (
            e.target.files[0].type == "image/png" ||
            e.target.files[0].type == "image/jpeg"
          ) {
            validateStep1Input();
            previewProfilePic(e.target.files[0]);
            setFormData((user) => {
              return { ...user, [e.target.name]: e.target.files[0] };
            });
          } else {
            toast.error("File format is not supported");
          }
        } else {
          const { value, name } = e.target;

          setFormData((user) => {
            return { ...user, [name]: value };
          });
        }
        // formData?.organization_name === "" ? setInitialPercentage(initialPercentage+10) : initialPercentage-10 <=0 ? setInitialPercentage(initialPercentage-10) : setInitialPercentage(0)
      } catch (error) {}

      // try {
      //   if (e.target.name === "uploadResume") {
      //     setFormData((user) => {
      //       return { ...user, [e.target.name]: e.target.files[0] };
      //     });
      //   } else if (e.target.name === "uploadProfilePic") {
      //     validateStep1Input();
      //     previewProfilePic(e.target.files[0]);
      //     setFormData((user) => {
      //       return { ...user, [e.target.name]: e.target.files[0] };
      //     });
      //   } else {
      //     const { value, name } = e.target;

      //     setFormData((user) => {
      //       return { ...user, [name]: value };
      //     });
      //   }
      // } catch (error) {}

      if (activeStep === 0) {
        if (!validateStep1Input()) {
          setHasInvalidSubmitOccurred(true);
        } else {
          // setActiveStep(activeStep + 1);
        }
      } else if (activeStep === 1) {
        setInitialPercentage(Math.round((1 / steps.length) * 100));
        if (!validateStep2Input()) {
          setHasInvalidSubmitOccurred(true);
        } else {
          // setActiveStep(activeStep + 1);
        }
      } else if (activeStep === 2) {
        if (!validateStep3Input()) {
          setHasInvalidSubmitOccurred(true);
        } else {
          // setActiveStep(activeStep + 1);
        }
      } else if (activeStep === 3) {
        if (!validateStep4Input()) {
        } else {
          // setActiveStep(activeStep + 1);
        }
      }
    };

    const { ValueContainer, Placeholder } = components;

    const CustomValueContainer = ({ children, ...props }) => {
      return (
        <ValueContainer {...props}>
          <Placeholder {...props} isFocused={props.isFocused}>
            {props.selectProps.placeholder}
          </Placeholder>
          {React.Children.map(children, (child) =>
            child && child.key !== "placeholder" ? child : null
          )}
        </ValueContainer>
      );
    };

    switch (step) {
      case 0:
        return (
          <>
            <div
              className="mentorformsteps row"
              style={{ paddingBottom: "10px", paddingTop: "10px" }}
            >
              <InputField
                required={true}
                id="full_name"
                label="Full Name"
                variant="outlined"
                fullWidth
                disabled={true}
                margin="normal"
                onChange={handleInputChange}
                value={formData && formData.full_name}
                name="full_name"
                error={error.fullname}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />

              <div className="file_upload">
                <div className="rowC ">
                  {/* <p className="upload-mentor-text">
                    Upload Profile Picture
                    <span>
                      Supported file format jpeg, png only upto 500KB
                    </span> */}
                  <div className="col-md-9">
                    <p class="upload-mentor-text">
                      Upload Profile Picture (OPTIONAL){" "}
                    </p>
                    <p style={{ textAlign: "left", lineHeight: "18px" }}>
                      <br />
                      <input
                        type="file"
                        // name="Upload Document"
                        name="uploadProfilePic"
                        id="fileUpload-profile"
                        // accept="image/*"
                        accept="image/png, image/jpeg"
                        // accept="application/pdf, application/vnd.ms-excel"
                        onChange={handleInputChange}
                        onBlur={onBlur}
                        className="inputImageButton"
                        style={{ width: "70%" }}

                        // onchange="document.getElementById('blah').src = window.URL.createObjectURL(this.files[0])"
                      />
                      <span className="supported-file homepageSecondDescription">
                        Supported file format jpeg, png only upto 500KB
                      </span>
                    </p>
                  </div>

                  <img
                    className="col-md-3 uploadedPic"
                    id="fileUpload-profile-pic"
                    src={
                      formData.uploadProfilePic
                        ? previewProfilePic(
                            formData && formData.uploadProfilePic
                          )
                        : profileExistingImg
                    }
                    // style={{
                    //   width: "5rem",
                    //   marginLeft: "15px",
                    //   marginTop: "5px",
                    //   height: "60px",
                    //   fontSize:"18px",
                    // }}
                  />
                </div>
              </div>

              {error.uploadProfilePic &&
                renderErrorMessage(error.uploadProfilePic)}
              <InputField
                required={true}
                id="organization_name"
                label="Current Organization Name"
                variant="outlined"
                fullWidth
                margin="normal"
                name="organization_name"
                validatePassword
                className="col-12"
                style={{ fontSize: "18px !important" }}
                onChange={handleInputChange}
                value={formData.organization_name}
                error={error.orgName}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />

              <InputField
                required={true}
                id="current_designation"
                label="Current Designation"
                variant="outlined"
                fullWidth
                margin="normal"
                name="current_designation"
                className="col-12"
                onChange={handleInputChange}
                value={formData.current_designation}
                error={error.currentDesgnation}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
            </div>
          </>
        );
      case 1:
        return (
          <>
            <div className="mentorformsteps row">
              <InputField
                required={true}
                id="email_id"
                label="E-mail"
                variant="outlined"
                fullWidth
                margin="normal"
                name="email_id"
                disabled={true}
                className="col-12"
                onChange={handleInputChange}
                value={formData.email_id}
                error={error.email_id}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />

              <PhoneInput
                country={selectedCountry}
                value={phonevalue}
                countryCodeEditable={false}
                style={{ fontSize: "15px" }}
                onChange={(phonevalue, country) => {
                  const phoneCountryObject = {
                    value: country.countryCode.toUpperCase(),

                    label: country.name,
                  };

                  setFormData((user) => {
                    return {
                      ...user,
                      country: phoneCountryObject,
                    };
                  });

                  setFormData((user) => {
                    return { ...user, country_name: country.name };
                  });

                  setSelectedCountry(country.countryCode);
                  setPhoneValue(phonevalue);
                  // setTempPhoneValue(phonevalue)
                }}
                error={error.phonevalue}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
              {error.phonevalue && renderErrorMessage(error.phonevalue)}
              {/* <GlobalDropDown
                required={true}
                id="gender"
                label="Gender*"
                variant="outlined"
                fullWidth
                margin="normal"
                name="gender"
                className="col-12"
                // style={{marginBottom:"5px"}}
                onChange={handleInputChange}
                value={formData.gender}
                option={genders}
                // type="Gender"
                // error={error.gender}
                
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                // InputProps={{
                //   classes: {
                //     // root: classes.textFieldRoot,
                //     focused: classes.textFieldFocused,
                //     // notchedOutline: classes.textFieldNotchedOutline
                //   },
                // }}
              /> */}

              <div
                style={{
                  paddingTop: "5px",
                  paddingBottom: "0",
                  color: "gray",
                  textAlign: "left",
                  fontSize: "15px",
                  fontFamily: "Montserrat",

                  paddingLeft: "5px",
                }}
                className="homepageSecondDescription"
              >
                Gender *
              </div>
              <Select
                required={true}
                id="gender"
                // label="Gender*"
                variant="outlined"
                fullWidth
                margin="normal"
                name="gender"
                className="col-12 gendermentorinput largeSelect"
                // styles={customStyles}
                styles={customStyles}
                value={formData.gender}
                // defaultValue={genderOption}
                // onChange={handleInputChange}
                onChange={(e) => {
                  // setGender(e.value);
                  setFormData((user) => {
                    return { ...user, gender: e };
                  });
                }}
                maxMenuHeight={300}
                onFocus={() => setGenderFocused(true)}
                // onBlur={() => setGenderFocused(false)}
                isFocused={genderfocused}
                // placeholder="My Cool Label and work Focused"
                // isClearable
                // components={{
                //   ValueContainer: CustomValueContainer,
                // }}
                options={genders}
                placeholder="Gender*"
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
              {error.gender && renderErrorMessage(error.gender)}
              {/* <GlobalDropDown
                required={true}
                id="country"
                label="Country*"
                variant="outlined"
                fullWidth
                margin="normal"
                name="country"
                className="col-12"
                // style={{marginBottom:"5px"}}
                onChange={handleInputChange}
                value={formData.country}
                option={Country.getAllCountries()}
                type="Country"
                error={error.country}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                // InputProps={{
                //   classes: {
                //     // root: classes.textFieldRoot,
                //     focused: classes.textFieldFocused,
                //     // notchedOutline: classes.textFieldNotchedOutline
                //   },
                // }}
              /> */}
              <div
                style={{
                  paddingTop: "5px",
                  paddingBottom: "0",
                  color: "gray",
                  textAlign: "left",
                  fontSize: "15px",
                  fontFamily: "Montserrat",

                  // paddingLeft: "5px",
                }}
                className="homepageSecondDescription"
              >
                Country *
              </div>
              <Select
                required={true}
                id="country"
                // label="Gender*"
                variant="outlined"
                fullWidth
                margin="normal"
                type="Country"
                name="country"
                className="col-12 countrymentorinput"
                // styles={customStylesCountry}
                styles={customStyles}
                // value={cityValue}
                value={formData.country}
                // defaultValue={genderOption}
                // onChange={handleInputChange}
                onChange={(e) => {
                  // setGender(e.value);
                  generatePercentageData("countryChange");
                  setFormData((user) => {
                    return { ...user, country: e };
                  });
                  if (e.value === "IN") {
                    // setSelectedCountry(e.value.toLowerCase());
                    setPhoneValue(tempPhoneValue);
                    // setTriggerVal
                    // setPhoneValue(tempPhoneValue)
                  } else {
                    setPhoneValue("");
                    setSelectedCountry(e.value.toLowerCase());
                  }

                  setFormData((user) => {
                    return { ...user, country_name: e.label };
                  });

                  setFormData((user) => {
                    return { ...user, state: "" };
                  });
                  setFormData((user) => {
                    return { ...user, state_name: "" };
                  });

                  setFormData((user) => {
                    return { ...user, city: "" };
                  });

                  setFormData((user) => {
                    return { ...user, city_name: "" };
                  });
                }}
                // theme={(theme) => ({
                //   ...theme,
                //   // borderRadius: 0,
                //   spacing: {
                //     ...theme.spacing,
                //     baseUnit: 2,
                //     controlHeight: 30,
                //     menuGutter: 8,
                //   },
                // })}
                maxMenuHeight={300}
                onFocus={() => setFocused(true)}
                // onBlur={() => setFocused(false)}
                isFocused={focused}
                // placeholder="My Cool Label and work Focused"
                options={newCountryOptions}
                // isClearable
                // components={{
                //   ValueContainer: CustomValueContainer,
                // }}
                // options={Country.getAllCountries()}

                placeholder="Country*"
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />

              {error.country && renderErrorMessage(error.country)}

              {formData.country.value === "IN" ? (
                <>
                  {" "}
                  <div
                    className="col-md-6 col-sm-12 statecitymentorinput"
                    style={{ paddingLeft: "0px" }}
                  >
                    {/* <GlobalDropDown
                      required={true}
                      id="state"
                      label="State*"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12"
                      onChange={handleInputChange}
                      value={formData.state}
                      option={State.getStatesOfCountry(formData.country)}
                      type="State"
                      error={error.state}
                      onBlur={onBlur}
                      hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                    /> */}

                    <div
                      style={{
                        paddingTop: "5px",
                        paddingBottom: "0",
                        color: "gray",
                        textAlign: "left",
                        fontSize: "15px",
                        fontFamily: "Montserrat",

                        // paddingLeft: "5px",
                      }}
                      className="homepageSecondDescription"
                    >
                      State *
                    </div>
                    <Select
                      required={true}
                      id="state"
                      // label="Gender*"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      type="State"
                      name="state"
                      className="col-12 countrystartupinput"
                      // styles={customStyles}
                      styles={customStyles}
                      value={formData.state}
                      // defaultValue={genderOption}
                      // onChange={handleInputChange}
                      onChange={(e) => {
                        // setGender(e.value);

                        setFormData((user) => {
                          return { ...user, state: e };
                        });
                        setFormData((user) => {
                          return { ...user, state_name: e.label };
                        });
                        setFormData((user) => {
                          return { ...user, city: "" };
                        });

                        setFormData((user) => {
                          return { ...user, city_name: "" };
                        });
                        newStateOptionfunc(e.value);
                        stateAlreadySelectedState(e.value);
                      }}
                      maxMenuHeight={300}
                      onFocus={() => setStateFocused(true)}
                      // onBlur={() => setStateFocused(false)}
                      isFocused={statefocused}
                      // placeholder="My Cool Label and work Focused"
                      // isClearable
                      // components={{
                      //   ValueContainer: CustomValueContainer,
                      // }}
                      options={newStateOptions}
                      // options={Country.getAllCountries()}
                      // onBlur={onBlur}
                      placeholder="State*"
                      hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                    />
                    {error.state && renderErrorMessage(error.state)}
                  </div>
                  <div
                    className="col-md-6 col-sm-12 statecitymentorinput"
                    style={{
                      paddingRight: "0px",
                      // paddingTop: "5px"
                    }}
                  >
                    {/* <InputField
                      required={true}
                      id="city"
                      label="City"
                      variant="outlined"
                      placeholder="Enter City"
                      fullWidth
                      margin="normal"
                      name="city"
                      onChange={handleInputChange}
                      value={formData.city}
                      error={error.city}
                      onBlur={onBlur}
                      hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                    /> */}

                    <div
                      style={{
                        paddingTop: "5px",
                        paddingBottom: "0",
                        color: "gray",
                        textAlign: "left",
                        fontSize: "15px",
                        fontFamily: "Montserrat",

                        // paddingLeft: "5px",
                      }}
                      className="homepageSecondDescription"
                    >
                      City *
                    </div>
                    <Select
                      required={true}
                      id="city"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      type="City"
                      name="city"
                      className="col-12 countrystartupinput"
                      // styles={customStyles}
                      styles={customStyles}
                      value={formData.city}
                      onChange={(e) => {
                        setFormData((user) => {
                          return { ...user, city: e };
                        });

                        setFormData((user) => {
                          return { ...user, city_name: e.label };
                        });
                      }}
                      maxMenuHeight={300}
                      onFocus={() => setCityFocused(true)}
                      // onBlur={() => setCityFocused(false)}
                      // isFocused={cityfocused}
                      // placeholder="My Cool Label and work Focused"
                      // isClearable
                      // components={{
                      //   ValueContainer: CustomValueContainer,
                      // }}
                      options={newCityOptions}
                      // onBlur={onBlur}
                      placeholder="City*"
                      hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                    />
                    {error.city && renderErrorMessage(error.city)}
                  </div>
                </>
              ) : (
                <InputField
                  className="sm-mt-2 md-mt-0"
                  required={true}
                  id="city_name"
                  label="City"
                  variant="outlined"
                  placeholder="Enter City"
                  fullWidth
                  margin="normal"
                  marginTop="5px"
                  name="city_name"
                  onChange={(e) =>
                    setFormData((user) => {
                      return { ...user, ["city_name"]: e.target.value };
                    })
                  }
                  value={formData.city_name}
                  error={error.cityName}
                  onBlur={onBlur}
                  hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                />
              )}
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div className="mentorformsteps row">
              <h6 className="homepageSecondDescription">
                Why do you want to be a mentor at the Startup India mentorship
                program?*
              </h6>
              <InputField
                required={true}
                id="mentoratstartup"
                // label="Why do you want to be a mentor at the Startup India mentorship program?"
                variant="outlined"
                fullWidth
                margin="normal"
                name="mentoratstartup"
                className="col-12"
                multiline
                rows={2}
                style={{ paddingTop: "10px" }}
                maxRows={4}
                // onChange={handleInputChange}

                onChange={(e, name) => {
                  // if (testWordLimit(e.target.value) < 100) {
                  //   handleInputChange(e, name);
                  // }
                  const value = e.target.value;
                  const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                  const newerData = newData.replace(/[ ]{2,}/gi, " ");
                  if (
                    newerData.split(" ").length <= 101 &&
                    testWordLimit(newerData) < 101
                  ) {
                    handleInputChange(e, name);
                  }

                  setWordlimit(newerData);
                }}
                value={formData.mentoratstartup}
                // error={error.mentoratstartup}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />

              <div
                className="wordCounter"
                style={{ fontWeight: "bold", textAlign: "right" }}
              >
                Word Count:{" "}
                {formData.mentoratstartup?.length === 0
                  ? 0
                  : wordLimit?.length === 0
                  ? 0
                  : formData.mentoratstartup
                      ?.replace(/(^\s*)|(\s*$)/gi, "")
                      ?.replace(/[ ]{2,}/gi, " ")
                      ?.split(" ")?.length}{" "}
                / 100
              </div>

              {errorVisible7 ? renderErrorMessage(errorMessagePurpose) : ""}

              <h6 className="homepageSecondDescription">
                How many hours can you dedicate for providing mentorship per
                week?*
              </h6>

              <InputField
                required={true}
                id="hoursperweek"
                variant="outlined"
                // placeholder=""
                // label="How many hours can you dedicate for providing mentorship per week?"
                fullWidth
                type="number"
                margin="normal"
                name="hoursperweek"
                className="hourBox col-12"
                style={{ paddingTop: "10px" }}
                onChange={handleInputChange}
                // inputProps={{ max:3 }}

                onInput={(e) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 3);
                }}
                value={formData.hoursperweek}
                error={error.hoursperweek}
                onBlur={onBlur}
                onKeyDown={(e) =>
                  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                }
                InputLabelProps={{
                  shrink: true,
                }}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
            </div>
          </>
        );
      case 3:
        return (
          <>
            <div
              className="mentorformsteps row"
              style={{ paddingBottom: "10px" }}
            >
              <span
                class="d-inline-block multiselectorspan"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                <h6 className="homepageSecondDescription">
                  Industry / Sector (multiple selections upto 5) *
                </h6>

                <MultiselectorComp
                  options={
                    predefineOptionsList &&
                    predefineOptionsList.industry_options
                  }
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="Industry (multiple selections upto 5)"
                  styles={customStyles} //setIndustry(v)
                  onChange={(list) =>
                    list.length < 6
                      ? setFormData((user) => {
                          let arr = list.filter(function (item) {
                            return item.value !== "select";
                          });
                          if (list.length === 5) {
                            swal({
                              title: "Info!",
                              text: "Maximum limit 5 Reached for Industry / Sector",
                              icon: "info",
                            });
                          }
                          return { ...user, industry: arr };
                        })
                      : swal({
                          title: "Info!",
                          text: "Maximum limit 5 Reached for Industry / Sector",
                          icon: "info",
                        })
                  }
                  value={formData.industry}
                  onBlur={onBlur}
                />
              </span>
              {error.industry && renderErrorMessage(error.industry)}
              <span
                class="d-inline-block multiselectorspan"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                <div
                  className={
                    formData.subspecialization.length === 10
                      ? "top-btn tooltipicon"
                      : ""
                  }
                >
                  <h6
                    className={
                      formData.subspecialization.length === 10
                        ? "industryDisabled homepageSecondDescription"
                        : "homepageSecondDescription"
                    }
                  >
                    Industry / Sector - Keywords (Industry/Function Keywords
                    selection upto 10 combined)*
                  </h6>
                  <MultiselectorComp
                    options={
                      predefineOptionsList && predefineOptionsList.sub_industry
                    }
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    placeholder="Industry/Sector"
                    styles={customStyles} //setIndustry(v)
                    onChange={(list) =>
                      list.length <= 10 - formData.subspecialization.length
                        ? setFormData((user) => {
                            let arr = list.filter(function (item) {
                              return item.value !== "select";
                            });
                            if (
                              list.length + formData.subspecialization.length ==
                              10
                            ) {
                              swal({
                                title: "Info!",
                                text: "Maximum limit 10 Reached for Industry and Function Keywords combined",
                                icon: "info",
                              });
                            }
                            return { ...user, subindustry: arr };
                          })
                        : swal({
                            title: "Info",
                            text: "Maximum limit 10 Reached for Industry and Function Keywords combined",
                            icon: "info",
                          })
                    }
                    value={formData.subindustry}
                    onBlur={onBlur}
                    isDisabled={
                      formData.subspecialization.length === 10 ? true : false
                    }
                  />
                  <span
                    className={
                      formData.subspecialization.length === 10
                        ? "tooltiptext4"
                        : "d-none"
                    }
                  >
                    Can not add more than 10 keywords
                  </span>
                </div>
              </span>
              {error.subindustry && renderErrorMessage(error.subindustry)}
              <span
                class="d-inline-block multiselectorspan"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                <h6 className="homepageSecondDescription">
                  Specialization / Function (multiple selections upto 3) *
                </h6>
                <MultiselectorComp
                  options={
                    predefineOptionsList && predefineOptionsList._specialisation
                  }
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="Specialization (multiple selections upto 3)"
                  styles={customStyles}
                  // onChange={(v) => (v.length < 4 ? setSpecialization(v) : null)}
                  onChange={(list) =>
                    list.length < 4
                      ? setFormData((user) => {
                          let arr = list.filter(function (item) {
                            return item.value !== "select";
                          });
                          if (list.length === 3) {
                            swal({
                              title: "Info!",
                              text: "Maximum limit 3 Reached for Specialization / Function",
                              icon: "info",
                            });
                          }
                          return { ...user, specialization: arr };
                        })
                      : swal({
                          title: "Info",
                          text: "Maximum limit 3 Reached for Specialization / Function",
                          icon: "info",
                        })
                  }
                  value={formData.specialization}
                  onBlur={onBlur}
                />
              </span>
              {error.specialization && renderErrorMessage(error.specialization)}
              <span
                class="d-inline-block multiselectorspan"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                <div
                  className={
                    formData.subindustry.length === 10
                      ? "top-btn tooltipicon"
                      : ""
                  }
                >
                  <h6
                    className={
                      formData.subindustry.length === 10
                        ? "industryDisabled homepageSecondDescription"
                        : "homepageSecondDescription"
                    }
                  >
                    Specialization / Function -(Industry/Function Keywords
                    selection upto 10 Combined)*
                  </h6>
                  <MultiselectorComp
                    options={
                      predefineOptionsList &&
                      predefineOptionsList.functional_areas
                    }
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    placeholder="Specialization/Function"
                    styles={customStyles}
                    // onChange={(v) => (v.length < 4 ? setSpecialization(v) : null)}
                    onChange={(list) =>
                      list.length < 11 - formData.subindustry.length
                        ? setFormData((user) => {
                            // return { ...user, subspecialization: list };
                            let arr = list.filter(function (item) {
                              return item.value !== "select";
                            });
                            if (
                              list.length + formData.subindustry.length ==
                              10
                            ) {
                              swal({
                                title: "Info",
                                text: "Maximum limit 10 Reached for Industry and Function Keywords combined",
                                icon: "info",
                              });
                            }
                            return { ...user, subspecialization: arr };
                          })
                        : swal({
                            title: "Info",
                            text: "Maximum limit 10 Reached for Industry and Function Keywords combined",
                            icon: "info",
                          })
                    }
                    value={formData.subspecialization}
                    onBlur={onBlur}
                    isDisabled={
                      formData.subindustry.length === 10 ? true : false
                    }
                  />
                  <span
                    className={
                      formData.subindustry.length === 10
                        ? "tooltiptext4"
                        : "d-none"
                    }
                  >
                    Can not add more than 10 keywords
                  </span>
                </div>
              </span>
              {error.subspecialization &&
                renderErrorMessage(error.subspecialization)}
              <span
                class="d-inline-block multiselectorspan"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                <h6 className="homepageSecondDescription">
                  Preferred stage of the startup *
                </h6>
                <MultiselectorComp
                  options={
                    predefineOptionsList &&
                    predefineOptionsList.stage_of_startup_options
                  }
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="Preferred stage of the startup"
                  styles={customStyles}
                  onChange={(list) =>
                    setFormData((user) => {
                      let arr = list.filter(function (item) {
                        return item.value !== "*" && item.value !== "select";
                      });
                      return { ...user, preferredStage: arr };
                    })
                  }
                  // onChange={
                  //   (v) =>
                  //     setPreferredStage(v)
                  // }
                  onBlur={onBlur}
                  value={formData.preferredStage}
                />
              </span>
              {error.preferredStage && renderErrorMessage(error.preferredStage)}
              <span
                class="d-inline-block multiselectorspan"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                {/* <h6>Keywords</h6>
                <MultiselectorComp
                  options={keywords}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="keywords (multiple selections upto 5)"
                  styles={customStyles}
                  // onChange={(v) => (v.length < 4 ? setSpecialization(v) : null)}
                  onChange={(list) =>
                    list.length < 4
                      ? setFormData((user) => {
                          return { ...user, keywords: list };
                        })
                      : null
                  }
                  value={formData.keywords}
                  onBlur={onBlur}
                /> */}
              </span>
              {error.keywords && renderErrorMessage(error.keywords)}
            </div>
          </>
        );
      case 4:
        return (
          <>
            <div className="mentorformsteps row">
              <h6 className="question-heading homepageSecondDescription">
                LinkedIn profile URL
              </h6>
              <InputField
                id="linkedinurl"
                // label="LinkedIn profile URL"
                placeholder="Type Here URL (e.g. prefix with http:// or https://)"
                variant="outlined"
                fullWidth
                margin="normal"
                name="linkedinurl"
                className="col-12"
                onChange={handleInputChange}
                error={error.linkedinurl}
                value={formData.linkedinurl}
              />

              <div style={{ height: "60px" }} className="file_upload">
                <div>
                  <p class="upload-mentor-text">Upload Resume/Profile *</p>
                  <p style={{ textAlign: "left" }}>
                    <br />
                    <input
                      // onBlur={onBlur}
                      type="file"
                      // name="Upload Document"
                      id="fileUpload-resume"
                      required
                      name="uploadResume"
                      onChange={handleInputChange}
                      accept="application/pdf"
                      onBlur={onBlur}
                      style={{ width: "36%" }}
                      className="inputImageButton2"
                      //  onchange="document.getElementById('blah').src = window.URL.createObjectURL(this.files[0])"
                    />
                    <span className="supported-file-resume">
                      Supported file format PDF only upto 2MB
                    </span>
                  </p>
                </div>
              </div>
              {formData?.uploadResume &&
              formData?.uploadResume?.name !== null ? (
                <div className="file-name">
                  {formData.uploadResume.name
                    ? formData.uploadResume.name
                    : formData.uploadResume.substring(
                        formData.uploadResume.lastIndexOf("/") + 1
                      )}{" "}
                  <span
                    style={{ marginLeft: "10px" }}
                    onClick={() => removeFile("uploadResume")}
                  >
                    {" "}
                    X{" "}
                  </span>
                </div>
              ) : (
                formData.uploadResume && (
                  <div className="file-name">
                    {formData.uploadResume &&
                      formData.uploadResume.split("/").pop()}
                    <span
                      style={{ marginLeft: "10px" }}
                      onClick={() => removeFile("uploadResume")}
                    >
                      {" "}
                      X{" "}
                    </span>
                  </div>
                )
              )}
              {error.uploadResume && renderErrorMessage(error.uploadResume)}
              <h6 className="question-heading homepageSecondDescription">
                Personal blog/website/URL
              </h6>
              <InputField
                id="personalblogurl"
                placeholder="Type Here URL (e.g. prefix with http:// or https://)"
                // label="Personal blog/website/URL"

                variant="outlined"
                fullWidth
                margin="normal"
                name="personalblogurl"
                error={error.personalblogurl}
                className="col-12"
                onChange={handleInputChange}
                value={formData.personalblogurl}
              />
            </div>
            <div className="mentorformsteps row">
              <InputField
                required={false}
                id="shortDesription"
                label="Short Description (Up to 200 words)"
                variant="outlined"
                fullWidth
                margin="normal"
                name="shortDesription"
                className="col-12"
                multiline
                rows={2}
                maxRows={4}
                // onChange={handleInputChange}
                onChange={(e, name) => {
                  // if (testWordLimit(e.target.value) < 100) {
                  //   handleInputChange(e, name);
                  // }
                  const value = e.target.value;
                  const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                  const newerData = newData.replace(/[ ]{2,}/gi, " ");
                  if (
                    newerData.split(" ").length <= 201 &&
                    testWordLimit2(newerData) < 201
                  ) {
                    handleInputChange(e, name);
                  }

                  setWordlimit2(newerData);
                }}
                value={formData.shortDesription}
                error={error.shortDesription}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
              <div
                className="wordCounter"
                style={{ fontWeight: "bold", textAlign: "right" }}
              >
                Word Count:{" "}
                {formData.shortDesription?.length === 0
                  ? 0
                  : wordLimit2?.length === 0
                  ? 0
                  : formData.shortDesription
                      ?.replace(/(^\s*)|(\s*$)/gi, "")
                      ?.replace(/[ ]{2,}/gi, " ")
                      ?.split(" ")?.length}{" "}
                / 200
              </div>
            </div>
            <div className="mentorformsteps">
              <div className="disclaimerMaindiv">
                <Checkbox
                  checked={formData.disclaimer}
                  onClick={() => oncheckedChange()}
                  sx={{
                    color: "#F78F54",
                    "&.Mui-checked": {
                      color: "#F78F54",
                    },
                  }}
                />
                <div className="actualdisclaimer homepageSecondDescription">
                  All information provided by us in the application is true,
                  correct and complete and no information material to the
                  subject matter of this form has been suppressed or concealed.
                  If there is any change in this information or compliance
                  status, I will duly inform Startup India within 15 days on
                  startup.support@investindia.org.in
                </div>
              </div>
              {/* {alert(formData.disclaimer)} */}
              {formData.disclaimer === true
                ? " "
                : error.disclaimer && renderErrorMessage(error.disclaimer)}
            </div>
          </>
        );
      default:
        return "unknown step";
    }
  }

  const steps = getSteps();
  const allStepsData = steps.map((step, index) => {
    return (
      <li
        className={
          activeStep === index
            ? "active"
            : index < activeStep
            ? "active"
            : "lastStep"
        }
        key={index}
      >
        <span className="count">
          {/* <span>
            {percentageData}
          </span> */}
          {activeStep == index ? <>{Math.round(formPercentageValue)}%</> : ""}
          {/* {index === 0 ? (
            <span>
              {activeStep == index ? <>{initialPercentage}</> : activeStep === 1 ? <>20%</> : ""}
            </span>
          ) : index !== 5 ? (
            <span>
              {activeStep === index + 1
                ? Math.round(((index + 1) / steps.length) * 100) + "%"
                : ""}
            </span>
          ) : (
            <span>100%</span>
          )} */}
          {/* <span>
            {index === 0
              ? initialPercentage + "%"
              : activeStep === index + 1
              ? Math.round(((index + 1) / steps.length) * 100) + "%"
              : index + 1 <= activeStep
              ? Math.round(((index + 1) / steps.length) * 100) + "%"
              : ""}
          </span> */}
        </span>
        <div className="text homepageSecondDescription">
          <p>{step}</p>
        </div>
      </li>
    );
  });
  const isStepOptional = (step) => {
    return step === 1 || step === 2;
  };

  const newStateOptionfunc = (state) => {
    City.getCitiesOfState("IN", state).map((item) => {
      const newObject = {
        value: item.name,
        label: item.name,
      };

      newCityArray.push(newObject);
      setNewCityOptions(newCityArray);
    });
  };

  const isStepSkipped = (step) => {
    return skippedSteps.includes(step);
  };

  const handleNext = () => {
    generatePercentageData();
    let value = localStorage.getItem("SavedLoggedInData");
    let LoginData = JSON.parse(value);
    // let form_data = new FormData();
    // form_data.append("name", formData.city);
    // const jsonData = JSON.parse(formData);
    // let form_data = new FormData();
    // form_data.append("mentorformdata", JSON.stringify(formData));

    setSubmitFormData(formData);
    if (activeStep === 0) {
      if (!validateStep1Input()) {
        setHasInvalidSubmitOccurred(true);
      } else {
        setActiveStep(activeStep + 1);
        if (
          LoginData.applicationStatus != "SUBMITTED" ||
          LoginData.applicationStatus != "VERIFIED" ||
          LoginData.applicationStatus != "REQUESTINFO" ||
          LoginData.applicationStatus != "REJECTED" ||
          LoginData.applicationStatus != "UPDATEDINFO"
        ) {
          if (action === "VERIFIED" || action === "EditApplication") {
          } else {
            addDraftData(formData, "nextdraftbutton");
          }
        } else {
        }
      }
    } else if (activeStep === 1) {
      setInitialPercentage(Math.round((1 / steps.length) * 100));
      if (!validateStep2Input()) {
        setHasInvalidSubmitOccurred(true);
      } else {
        setActiveStep(activeStep + 1);
        // addDraftData(formData, "nextdraftbutton");
        if (
          LoginData.applicationStatus != "SUBMITTED" ||
          LoginData.applicationStatus != "VERIFIED" ||
          LoginData.applicationStatus != "REQUESTINFO" ||
          LoginData.applicationStatus != "REJECTED" ||
          LoginData.applicationStatus != "UPDATEDINFO"
        ) {
          if (action === "VERIFIED" || action === "EditApplication") {
          } else {
            addDraftData(formData, "nextdraftbutton");
          }
        } else {
        }
      }
    } else if (activeStep === 2) {
      if (!validateStep3Input()) {
        setHasInvalidSubmitOccurred(true);
      } else {
        setActiveStep(activeStep + 1);
        // addDraftData(formData, "nextdraftbutton");
        if (
          LoginData.applicationStatus != "SUBMITTED" ||
          LoginData.applicationStatus != "VERIFIED" ||
          LoginData.applicationStatus != "REQUESTINFO" ||
          LoginData.applicationStatus != "REJECTED" ||
          LoginData.applicationStatus != "UPDATEDINFO"
        ) {
          if (action === "VERIFIED" || action === "EditApplication") {
          } else {
            addDraftData(formData, "nextdraftbutton");
          }
        } else {
        }
      }
      // addDraftData(formData, "nextdraftbutton");
    } else if (activeStep === 3) {
      if (!validateStep4Input()) {
        setHasInvalidSubmitOccurred(true);
      } else {
        setActiveStep(activeStep + 1);
        // addDraftData(formData, "nextdraftbutton");
        if (
          LoginData.applicationStatus != "SUBMITTED" ||
          LoginData.applicationStatus != "VERIFIED" ||
          LoginData.applicationStatus != "REQUESTINFO" ||
          LoginData.applicationStatus != "REJECTED" ||
          LoginData.applicationStatus != "UPDATEDINFO"
        ) {
          if (action === "VERIFIED" || action === "EditApplication") {
          } else {
            addDraftData(formData, "nextdraftbutton");
          }
        } else {
        }
      }
    } else if (activeStep === 4) {
      // setTimeout(() => {
      //   addDraftData(formData, "nextdraftbutton");
      // }, 1500);
      if (!validateStep5Input()) {
        setHasInvalidSubmitOccurred(true);
      } else {
        setActiveStep(activeStep + 1);
        setTimeout(() => {
          addFormData(formData);
        }, 1500);
      }
    }

    setSkippedSteps(skippedSteps.filter((skipItem) => skipItem !== activeStep));
  };

  // const handleNext = () => {
  //   // let form_data = new FormData();
  //   // form_data.append("name", formData.city);
  //   // const jsonData = JSON.parse(formData);
  //   // let form_data = new FormData();
  //   // form_data.append("mentorformdata", JSON.stringify(formData));

  //   setSubmitFormData(formData);
  //   if (activeStep === 0) {
  //     if (!validateStep1Input()) {
  //       setHasInvalidSubmitOccurred(true);
  //     } else {
  //       setActiveStep(activeStep + 1);
  //     }
  //   } else if (activeStep === 1) {
  //     setInitialPercentage(Math.round((1 / steps.length) * 100));
  //     if (!validateStep2Input()) {
  //       setHasInvalidSubmitOccurred(true);
  //     } else {
  //       setActiveStep(activeStep + 1);
  //     }
  //   } else if (activeStep === 2) {
  //     if (!validateStep3Input()) {
  //       setHasInvalidSubmitOccurred(true);
  //     } else {
  //       setActiveStep(activeStep + 1);
  //     }
  //   } else if (activeStep === 3) {
  //     if (!validateStep4Input(keywordsCount)) {
  //       setHasInvalidSubmitOccurred(true);
  //     } else {
  //       setActiveStep(activeStep + 1);
  //     }
  //   } else if (activeStep === 4) {
  //     if (!validateStep5Input()) {
  //       setHasInvalidSubmitOccurred(true);
  //     } else {
  //       setActiveStep(activeStep + 1);
  //       setTimeout(() => {
  //         addFormData(formData);
  //       }, 1500);
  //       // setActiveStep(activeStep + 1);
  //       // const formdataparam = {
  //       //   full_name: formData.full_name,
  //       //   uploadProfilePic: formData.uploadProfilePic,
  //       //   country: formData.country,
  //       //   country_name: regionNames.of(formData.country),
  //       //   email_id: formData.email_id,
  //       //   phone_number: formData.phone_number,
  //       //   state: formData.state,
  //       //   city: formData.city,
  //       //   organization_name: formData.organization_name,
  //       //   current_designation: formData.current_designation,
  //       //   mentoratstartup: formData.mentoratstartup,
  //       //   hoursperweek: formData.hoursperweek,
  //       //   linkedinurl: formData.linkedinurl,
  //       //   personalblogurl: formData.personalblogurl,
  //       //   uploadResume: formData.uploadResume,
  //       //   disclaimer: formData.disclaimer,
  //       //   industry: formData.industry,
  //       //   specialization: formData.specialization,
  //       //   preferredStage: formData.preferredStage,
  //       //   shortDesription: formData.shortDesription,
  //       // };

  //       // let form_data = new FormData();

  //       // form_data.append("mentorformdata", JSON.stringify(formdataparam));
  //       // setSubmitFormData(form_data);
  //     }
  //   }

  //   setSkippedSteps(skippedSteps.filter((skipItem) => skipItem !== activeStep));
  // };
  const handleDraft = () => {
    if (activeStep === 0) {
      // if (!validateStep1Input()) {
      //   // setHasInvalidSubmitOccurred(true);
      //   addDraftData(formData);
      // } else {
      //   // setActiveStep(activeStep + 1);
      //   addDraftData(formData);
      // }
      addDraftData(formData, "savedraftbutton");
    } else if (activeStep === 1) {
      // if (!validateStep2Input()) {
      //   setHasInvalidSubmitOccurred(true);
      // } else {
      //   // setActiveStep(activeStep + 1);
      //   addDraftData(formData);
      // }
      addDraftData(formData, "savedraftbutton");
    } else if (activeStep === 2) {
      // if (!validateStep3Input()) {
      //   setHasInvalidSubmitOccurred(true);
      // } else {
      //   // setActiveStep(activeStep + 1);
      //   addDraftData(formData);
      // }
      addDraftData(formData, "savedraftbutton");
    } else if (activeStep === 3) {
      // if (!validateStep4Input()) {
      // } else {
      //   // setActiveStep(activeStep + 1);
      //   addDraftData(formData);
      // }
      addDraftData(formData, "savedraftbutton");
    } else if (activeStep === 4) {
      // if (!validateStep5Input()) {
      //   setHasInvalidSubmitOccurred(true);
      // } else {
      //   // setActiveStep(activeStep + 1);
      //   addDraftData(formData);
      // }
      // addDraftData(formData);
      setTimeout(() => {
        addDraftData(formData, "savedraftbutton");
      }, 1500);
    }
    //  else if (activeStep === 5) {
    //   if (!validateStep6Input()) {
    //     setHasInvalidSubmitOccurred(true);
    //   } else {
    //     setActiveStep(activeStep + 1);
    //   }
    // }

    setSkippedSteps(skippedSteps.filter((skipItem) => skipItem !== activeStep));
    // setSubmitFormData(formData);
  };
  // const handleDraft = () => {
  //   if (activeStep === 0) {
  //     // if (!validateStep1Input()) {
  //     //   // setHasInvalidSubmitOccurred(true);
  //     //   addDraftData(formData);
  //     // } else {
  //     //   // setActiveStep(activeStep + 1);
  //     //   addDraftData(formData);
  //     // }
  //     addDraftData(formData);
  //   } else if (activeStep === 1) {
  //     // if (!validateStep2Input()) {
  //     //   setHasInvalidSubmitOccurred(true);
  //     // } else {
  //     //   // setActiveStep(activeStep + 1);
  //     //   addDraftData(formData);
  //     // }
  //     addDraftData(formData);
  //   } else if (activeStep === 2) {
  //     // if (!validateStep3Input()) {
  //     //   setHasInvalidSubmitOccurred(true);
  //     // } else {
  //     //   // setActiveStep(activeStep + 1);
  //     //   addDraftData(formData);
  //     // }
  //     addDraftData(formData);
  //   } else if (activeStep === 3) {
  //     // if (!validateStep4Input()) {
  //     // } else {
  //     //   // setActiveStep(activeStep + 1);
  //     //   addDraftData(formData);
  //     // }
  //     addDraftData(formData);
  //   } else if (activeStep === 4) {
  //     // if (!validateStep5Input()) {
  //     //   setHasInvalidSubmitOccurred(true);
  //     // } else {
  //     //   // setActiveStep(activeStep + 1);
  //     //   addDraftData(formData);
  //     // }
  //     // addDraftData(formData);
  //     setTimeout(() => {
  //       addDraftData(formData);
  //     }, 1500);
  //   }
  //   //  else if (activeStep === 5) {
  //   //   if (!validateStep6Input()) {
  //   //     setHasInvalidSubmitOccurred(true);
  //   //   } else {
  //   //     setActiveStep(activeStep + 1);
  //   //   }
  //   // }

  //   setSkippedSteps(skippedSteps.filter((skipItem) => skipItem !== activeStep));
  //   // setSubmitFormData(formData);
  // };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
    generatePercentageData(0);
  };

  // const addDraftData = (submitData) => {
  //   const newformData = new FormData();
  //   const industryArray = [];
  //   const subindustryArray = [];
  //   const specialityArray = [];
  //   const subspecialityArray = [];
  //   const preferedStageArray = [];
  //   const preferedsectormentor = [];
  //   const preferedfunctionsupport = [];
  //   const preferredStageArray = [];

  //   submitData &&
  //     submitData?.industry &&
  //     submitData?.industry.map((industry) => {
  //       industryArray.push(industry.value);
  //     });
  //   submitData &&
  //     submitData?.subindustry &&
  //     submitData?.subindustry.map((subindustry) => {
  //       subindustryArray.push(subindustry.value);
  //     });
  //   submitData &&
  //     submitData?.specialization &&
  //     submitData?.specialization.map((speciality) => {
  //       specialityArray.push(speciality.value);
  //     });
  //   submitData &&
  //     submitData?.subspecialization &&
  //     submitData?.subspecialization.map((subspeciality) => {
  //       subspecialityArray.push(subspeciality.value);
  //     });

  //   submitData &&
  //     submitData?.preferredStage &&
  //     submitData?.preferredStage.map((stage) => {
  //       preferedStageArray.push(stage.value);
  //     });

  //   const mentorapplication = {
  //     full_name: submitData.full_name,
  //     country: submitData.country.value,
  //     country_name: submitData.country_name,
  //     // country_name: submitData.country.label,
  //     email_id: submitData.email_id,
  //     // phone_number: submitData.phone_number,
  //     phone_number: phonevalue,
  //     state: submitData.state.value,
  //     state_name: submitData.state_name,
  //     city:
  //       submitData.country.value === "IN"
  //         ? submitData.city.label
  //         : submitData.city_name,
  //     city_name: submitData.city_name,
  //     gender: submitData.gender.value,
  //     organization_name: submitData.organization_name,
  //     current_designation: submitData.current_designation,
  //     mentoratstartup: submitData.mentoratstartup,
  //     hoursperweek: submitData.hoursperweek,
  //     linkedinurl: submitData.linkedinurl,
  //     personalblogurl: submitData.personalblogurl,
  //     disclaimer: submitData.disclaimer,
  //     industry: industryArray,
  //     subindustry: subindustryArray,
  //     specialization: specialityArray,
  //     subspecialization: subspecialityArray,
  //     preferredStage: preferedStageArray,
  //     shortDesription: submitData.shortDesription,
  //   };

  //   newformData.append("application", JSON.stringify(mentorapplication));
  //   newformData.append("uploadProfilePic", submitData.uploadProfilePic);
  //   newformData.append("uploadResume", submitData.uploadResume);
  //   let applicationStatusValue =
  //     props.location.action === "EditApplication"
  //       ? props.location.state && props.location.state.applicationStatus
  //       : "";

  //   savedraftMentor(newformData).then((res) => {
  //     if (res) {
  //       // if (res) {
  //       //   history.push({
  //       //     pathname: "/",
  //       //   });

  //       //   // onCloseBothModal();
  //       //   onClose();
  //       // }
  //       if (res) {
  //         // let value = localStorage.getItem("SavedLoggedInData");
  //         // let LoginData = JSON.parse(value);
  //         localStorage.removeItem("SavedLoggedInData");
  //         localStorage.removeItem("loggedIn");
  //         history.push({
  //           pathname: "/",
  //         });
  //       }
  //     }
  //   });
  //   // alert(applicationStatusValue)
  //   // registerMentor(
  //   //   newformData,
  //   //   submitData.email_id,
  //   //   applicationStatusValue
  //   // ).then((res) => {
  //   //   if (res) {
  //   //     if (res) {
  //   //       let value = localStorage.getItem("SavedLoggedInData");
  //   //       let LoginData = JSON.parse(value);
  //   //       if (LoginData.applicationStatus === "SUBMITTED") {
  //   //         localStorage.removeItem("SavedLoggedInData");
  //   //         localStorage.removeItem("loggedIn");
  //   //       } else if (applicationStatusValue === "VERIFIED") {
  //   //         history.push({
  //   //           pathname: "/dashboard",
  //   //         });
  //   //       } else {
  //   //         localStorage.removeItem("SavedLoggedInData");
  //   //         localStorage.removeItem("loggedIn");
  //   //         history.push({
  //   //           pathname: "/",
  //   //         });
  //   //       }

  //   //       //Update Login Data Call view mentor profile
  //   //       // onCloseBothModal();
  //   //       // onClose();
  //   //     }
  //   //   }
  //   // });
  //   // } else if (formName === "startup-form") {
  //   //   registerStartUp(formData).then((res) => {
  //   //     if (res) {
  //   //       if (res) {
  //   //         history.push({
  //   //           pathname: "/",
  //   //         });

  //   //         // onCloseBothModal();
  //   //         onClose();
  //   //       }
  //   //     }
  //   //   });
  //   // } else {
  //   //   registerCohort(formData).then((res) => {
  //   //     if (res) {
  //   //       if (res) {
  //   //         history.push({
  //   //           pathname: "/",
  //   //         });

  //   //         // onCloseBothModal();
  //   //         onClose();
  //   //       }
  //   //     }
  //   //   });
  //   // }
  // };

  const addDraftData = (submitData, buttontype) => {
    const newformData = new FormData();
    const industryArray = [];
    const subindustryArray = [];
    const specialityArray = [];
    const subspecialityArray = [];
    const preferedStageArray = [];
    const preferedsectormentor = [];
    const preferedfunctionsupport = [];
    const preferredStageArray = [];

    submitData &&
      submitData?.industry &&
      submitData?.industry.map((industry) => {
        industryArray.push(industry.value);
      });
    submitData &&
      submitData?.subindustry &&
      submitData?.subindustry.map((subindustry) => {
        subindustryArray.push(subindustry.value);
      });
    submitData &&
      submitData?.specialization &&
      submitData?.specialization.map((speciality) => {
        specialityArray.push(speciality.value);
      });
    submitData &&
      submitData?.subspecialization &&
      submitData?.subspecialization.map((subspeciality) => {
        subspecialityArray.push(subspeciality.value);
      });

    submitData &&
      submitData?.preferredStage &&
      submitData?.preferredStage.map((stage) => {
        preferedStageArray.push(stage.value);
      });

    const mentorapplication = {
      full_name: submitData.full_name,
      country: submitData.country.value,
      country_name: submitData.country_name,
      // country_name: submitData.country.label,
      email_id: submitData.email_id,
      // phone_number: submitData.phone_number,
      phone_number: phonevalue,
      state: submitData.state.value,
      state_name: submitData.state_name,
      city:
        submitData.country.value === "IN"
          ? submitData.city.label
          : submitData.city_name,
      city_name: submitData.city_name,
      gender: submitData.gender.value,
      organization_name: submitData.organization_name,
      current_designation: submitData.current_designation,
      mentoratstartup: submitData.mentoratstartup,
      hoursperweek: submitData.hoursperweek,
      linkedinurl: submitData.linkedinurl,
      personalblogurl: submitData.personalblogurl,
      disclaimer: submitData.disclaimer,
      industry: industryArray,
      subindustry: subindustryArray,
      specialization: specialityArray,
      subspecialization: subspecialityArray,
      preferredStage: preferedStageArray,
      shortDesription: submitData.shortDesription,
    };

    newformData.append("application", JSON.stringify(mentorapplication));
    newformData.append("uploadProfilePic", submitData.uploadProfilePic);
    newformData.append("uploadResume", submitData.uploadResume);
    let applicationStatusValue =
      props.location.action === "EditApplication"
        ? props.location.state && props.location.state.applicationStatus
        : props.location.action === "DRAFT"
        ? "DRAFT"
        : "";
    savedraftMentor(newformData, buttontype, applicationStatusValue).then(
      (res) => {
        if (res) {
          // if (res) {
          //   history.push({
          //     pathname: "/",
          //   });

          //   // onCloseBothModal();
          //   onClose();
          // }
          if (res && buttontype === "savedraftbutton") {
            // let value = localStorage.getItem("SavedLoggedInData");
            // let LoginData = JSON.parse(value);
            if (applicationStatusValue === "DRAFT") {
            }
            localStorage.removeItem("SavedLoggedInData");
            localStorage.removeItem("loggedIn");
            history.push({
              pathname: "/",
            });
          }
        }
      }
    );
    // alert(applicationStatusValue)
    // registerMentor(
    //   newformData,
    //   submitData.email_id,
    //   applicationStatusValue
    // ).then((res) => {
    //   if (res) {
    //     if (res) {
    //       let value = localStorage.getItem("SavedLoggedInData");
    //       let LoginData = JSON.parse(value);

    //       if (LoginData.applicationStatus === "SUBMITTED") {
    //         localStorage.removeItem("SavedLoggedInData");
    //         localStorage.removeItem("loggedIn");
    //       } else if (applicationStatusValue === "VERIFIED") {
    //         history.push({
    //           pathname: "/dashboard",
    //         });
    //       } else {
    //         localStorage.removeItem("SavedLoggedInData");
    //         localStorage.removeItem("loggedIn");
    //         history.push({
    //           pathname: "/",
    //         });
    //       }

    //       //Update Login Data Call view mentor profile
    //       // onCloseBothModal();
    //       // onClose();
    //     }
    //   }
    // });
    // } else if (formName === "startup-form") {
    //   registerStartUp(formData).then((res) => {
    //     if (res) {
    //       if (res) {
    //         history.push({
    //           pathname: "/",
    //         });

    //         // onCloseBothModal();
    //         onClose();
    //       }
    //     }
    //   });
    // } else {
    //   registerCohort(formData).then((res) => {
    //     if (res) {
    //       if (res) {
    //         history.push({
    //           pathname: "/",
    //         });

    //         // onCloseBothModal();
    //         onClose();
    //       }
    //     }
    //   });
    // }
  };
  const addFormData = (submitData) => {
    const newformData = new FormData();
    const industryArray = [];
    const subindustryArray = [];
    const specialityArray = [];
    const subspecialityArray = [];
    const preferedStageArray = [];
    const preferedsectormentor = [];
    const preferedfunctionsupport = [];
    const preferredStageArray = [];

    submitData?.industry.map((industry) => {
      industryArray.push(industry.value);
    });
    submitData?.subindustry.map((subindustry) => {
      subindustryArray.push(subindustry.value);
    });
    submitData?.specialization.map((speciality) => {
      specialityArray.push(speciality.value);
    });
    submitData?.subspecialization.map((subspeciality) => {
      subspecialityArray.push(subspeciality.value);
    });

    submitData?.preferredStage.map((stage) => {
      preferedStageArray.push(stage.value);
    });

    const mentorapplication = {
      full_name: submitData.full_name,
      country: submitData.country.value,
      country_name: submitData.country_name,
      // country_name: submitData.country.label,
      email_id: submitData.email_id,
      // phone_number: submitData.phone_number,
      phone_number: phonevalue,
      state: submitData.state.value,
      state_name: submitData.state_name,
      city:
        submitData.country.value === "IN"
          ? submitData.city.label
          : submitData.city_name,
      city_name: submitData.city_name,
      gender: submitData.gender.value,
      organization_name: submitData.organization_name,
      current_designation: submitData.current_designation,
      mentoratstartup: submitData.mentoratstartup,
      hoursperweek: submitData.hoursperweek,
      linkedinurl: submitData.linkedinurl,
      personalblogurl: submitData.personalblogurl,
      disclaimer: submitData.disclaimer,
      industry: industryArray,
      subindustry: subindustryArray,
      specialization: specialityArray,
      subspecialization: subspecialityArray,
      preferredStage: preferedStageArray,
      shortDesription: submitData.shortDesription,
    };

    newformData.append("application", JSON.stringify(mentorapplication));
    newformData.append("uploadProfilePic", submitData.uploadProfilePic);
    newformData.append("uploadResume", submitData.uploadResume);
    let applicationStatusValue = action
      ? action
      : props.location.action === "EditApplication"
      ? props.location.state && props.location.state.applicationStatus
      : "";
    // alert(applicationStatusValue)
    registerMentor(
      newformData,
      submitData.email_id,
      applicationStatusValue
    ).then((res) => {
      if (res) {
        if (res) {
          let value = localStorage.getItem("SavedLoggedInData");
          let LoginData = JSON.parse(value);

          if (LoginData.applicationStatus === "SUBMITTED") {
            localStorage.removeItem("SavedLoggedInData");
            localStorage.removeItem("loggedIn");
          } else if (
            applicationStatusValue === "VERIFIED" ||
            applicationStatusValue === "REQUESTINFO"
          ) {
            history.push({
              pathname: "/dashboard",
            });
          } else {
            localStorage.removeItem("SavedLoggedInData");
            localStorage.removeItem("loggedIn");
            history.push({
              pathname: "/",
            });
          }

          //Update Login Data Call view mentor profile
          // onCloseBothModal();
          // onClose();
        }
      }
    });
    // } else if (formName === "startup-form") {
    //   registerStartUp(formData).then((res) => {
    //     if (res) {
    //       if (res) {
    //         history.push({
    //           pathname: "/",
    //         });

    //         // onCloseBothModal();
    //         onClose();
    //       }
    //     }
    //   });
    // } else {
    //   registerCohort(formData).then((res) => {
    //     if (res) {
    //       if (res) {
    //         history.push({
    //           pathname: "/",
    //         });

    //         // onCloseBothModal();
    //         onClose();
    //       }
    //     }
    //   });
    // }
  };

  const handleSkip = () => {
    if (!isStepSkipped(activeStep)) {
      setSkippedSteps([...skippedSteps, activeStep]);
    }
    setActiveStep(activeStep + 1);
  };

  return (
    <div>
      <Stepper alternativeLabel activeStep={activeStep}>
        {
          <Step>
            <div className="row steps-mentor">
              <div className="col-12">
                <ul>{allStepsData}</ul>
              </div>
            </div>
          </Step>
        }
      </Stepper>

      {activeStep === steps.length ? (
        <Typography variant="h3" style={{ fontSize: "20px" }} align="center">
          Processing...Please Wait
        </Typography>
      ) : (
        <>
          <form>{getStepContent(activeStep)}</form>

          {activeStep === 0 ? (
            ""
          ) : (
            <a
              disabled={activeStep === 0}
              onClick={handleBack}
              className="brd-btn d-inline-block newbtnbottom"
              style={{
                backgroundColor: "#f4f4f4",
                // backgroundColor: "#f4f4f4",
                color: "#3AC2D7",
                // color: "#3AC2D7",
                width: "9em",
                marginTop: "20px",
                marginRight: "8px",
                border: "1px solid #00000040",
                borderRadius: "5px",
                paddingTop: "6px",
                paddingBottom: "6px",
                cursor: "pointer",
                zIndex: 0,
              }}
              // title=""
            >
              <i className="fa fa-arrow-left"></i> &nbsp;
              {activeStep === 0 ? "Cancel" : "Previous"}
            </a>
          )}
          {/* <a
            // disabled={activeStep === 0}
            // onClick={handleBack}
            onClick={handleDraft}
            className="brd-btn d-inline-block newbtnbottom"
            style={{
              backgroundColor: "#f4f4f4",
              // backgroundColor: "#f4f4f4",
              color: "#3AC2D7",
              // color: "#3AC2D7",
              width: "9em",
              marginTop: "20px",
              marginRight: "8px",
              border: "1px solid #00000040",
              borderRadius: "5px",
              paddingTop: "6px",
              paddingBottom: "6px",
              cursor: "pointer",
              zIndex: 0,
            }}
            // title=""
          >
            {"Save as draft"}
          </a> */}
          <a
            onClick={handleNext}
            className="brd-btn d-inline-block newbtnbottom"
            style={{
              backgroundColor: "#f4f4f4",
              // backgroundColor: "#f4f4f4",
              color: "#3AC2D7",
              // color: "#3AC2D7",
              width: "9em",
              marginTop: "20px",
              marginRight: "8px",
              border: "1px solid #00000040",
              borderRadius: "5px",
              paddingTop: "6px",
              paddingBottom: "6px",
              cursor: "pointer",
              zIndex: 0,
            }}
            // title=""
          >
            {steps && activeStep === steps.length - 1 ? "Submit" : "Next"}{" "}
            &nbsp;
            <i className="fa fa-arrow-right"></i>
          </a>
          {/* <i className="fa fa-arrow-left"></i> &nbsp; */}
          {draftApplicationStatus === "SUBMITTED" ||
          draftApplicationStatus === "VERIFIED" ||
          draftApplicationStatus === "REQUESTINFO" ||
          draftApplicationStatus === "REJECTED" ||
          draftApplicationStatus === "UPDATEDINFO" ? (
            ""
          ) : (
            <a
              // disabled={activeStep === 0}
              // onClick={handleBack}
              onClick={handleDraft}
              className="brd-btn d-inline-block newbtnbottom"
              style={{
                backgroundColor: "#f4f4f4",
                // backgroundColor: "#f4f4f4",
                color: "#3AC2D7",
                // color: "#3AC2D7",
                width: "9em",
                marginTop: "20px",
                marginRight: "8px",
                border: "1px solid #00000040",
                borderRadius: "5px",
                paddingTop: "6px",
                paddingBottom: "6px",
                cursor: "pointer",
                zIndex: 0,
              }}
              // title=""
            >
              {"Save as draft"}
            </a>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    applicationData: state.GetMentorFormReducer.getViewMentorApplicationData,
  };
};
export default connect(mapStateToProps, {
  registerMentor,
  savedraftMentor,
  getPredefineOptionsList,
  getViewMentorApplicationData,
})(withRouter(MentorFillupForm));
